/* Bazaar Bee COD order form (approved mockups/cod-form-compact.html, Full name and Mobile stacked; markup snippets/bb-cod-form.liquid).
   - Product page: the buy box's ORDER NOW opens the form for that product (1 / 2 / 3 packs).
   - Everywhere else: any checkout button / link (cart, cart drawer, quick buy) opens it for the whole cart
     (scripts call window.bbCheckout() instead of going to /checkout).
   - Prices come from our order server (cod-api), which asks Shopify (discounts + GST) and adds the delivery charge.
   - After the order: a one-time upsell picked automatically (Shopify's related products), then a thank-you screen.
   - "or pay online" (when allowed) goes to the normal Shopify checkout.
   - Texts, colours, optional fields (landmark / email / alternate mobile), delivery and upsell come from the COD app
     (shop metafield bb_cod.config, or <api>/config while it is blank); until then the built-in defaults work.
   - Templates (Phase 2, approved mockups/cod-phase2.html): sheet (as above), steps (name + mobile, then the address),
     popup (a centred card on phones too), dark (black + gold) and inline (the form sits in the product page buy box;
     everywhere else inline falls back to sheet). The COD app picks one, or A/B tests two (each visitor keeps their
     version: localStorage bb_ab). Preview: ?codtpl=<name> (this tab; ?codtpl=0 clears it), ?codopen=1 opens it once.
   - Half-filled forms: once the mobile number is valid the details go to our server (POST /lead) when the form is
     closed, after 2 idle minutes, when the page is hidden and on NEXT (steps); ?cod=<token> (WhatsApp link) refills them.
   - Ad events go through window.bbTrack (assets/bb-pixels.js).
   - Phase 3 (approved mockups/cod-phase3.html, "What customers see"): delivery rules per state / pincode (charge, days,
     no COD → Pay online only) and the COD fee, shown as the lines box; order bump (bump: true in /quote and /order;
     Cash on Delivery only); coupon box; prepaid choice (Cash on Delivery or "Pay online & save", a Shopify cart
     permalink with one discount code and the address filled in); downsell after "No thanks" on the upsell (POST
     /downsell, accepted through /upsell); a 409 { payOnline } from /order (high risk) switches the form to Pay online.
     The server stays the authority for every price; /quote gets the pincode + state code (the area rules) and the
     source (the bump rules).
   - Phase 4 (docs/phase4-spec.md §4, approved mockups/cod-partial-cod.html buyer screen 1): Partial COD. A 409
     { code: 'ADVANCE', advance } from /order swaps the payment cards for "Pay ₹X now · ₹Y on delivery" (+ "Pay in full online");
     everyone mode adds it as a third card ("Pay ₹X now · ₹Z OFF"). Paying it: POST /advance, then the Shopify checkout of the
     advance (draft order invoice; the server makes the COD order once it is paid) or Razorpay checkout.js in the form
     (POST /advance/verify answers like /order: upsell, thank you). In a no-COD area with Partial COD on, PAY ONLINE first
     asks /order whether an advance is taken there instead. Also the polish list: one live region, the page behind the
     sheet inert, whole-rupee prices, the quote warmed only on the first touch of the buy box or after 3 s.
   - Phase 5 (docs/phase5-location-insights-spec.md §4): Location insights counters, counts only. One 'visit' per browser
     session once the page is idle (when the COD app's geo.visits is on; sessionStorage bb_cod_visit), the product id
     (pid) on 'open', and one 'typed' (with the pid) per form open on the first input. An advance asked for a listed
     pincode (reason 'pin') is about the pincode, like 'area': another pincode lets /order decide again. */
(() => {
  if (window.BBCOD) return;
  const cfgEl = document.getElementById('bb-cod-config');
  const root = document.getElementById('bb-cod');
  if (!cfgEl || !root) return;
  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  const API = String(cfg.api || '').replace(/\/+$/, '');
  if (!API) return;
  // test mode: only in a browser that opened the store with ?codtest=1 (?codtest=0 switches it off again)
  let tester = false;
  try {
    const q = new URLSearchParams(location.search).get('codtest');
    if (q === '1') localStorage.setItem('bb_codtest', '1');
    if (q === '0') localStorage.removeItem('bb_codtest');
    tester = localStorage.getItem('bb_codtest') === '1';
  } catch (e) { tester = false; }
  const modeOk = (m) => m === 'live' || (m === 'test' && tester);
  if (!modeOk(cfg.mode)) return;
  let off = false; // the COD app's settings (fetched after the page was built) switched the form off
  const shopRoot = cfg.root || '/';
  const form = root.querySelector('[data-cod-step="1"]');
  if (!form) return;
  // the form can move into the product page (inline template): look in the sheet first, then in the form
  const $ = (s, r) => (r ? r.querySelector(s) : root.querySelector(s) || form.querySelector(s));
  const H = document.documentElement;
  const inr = (n) => '₹' + Math.round(Number(n) || 0).toLocaleString('en-IN'); // whole rupees (a GST quote can end in paise)
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const sized = (u, w) => (/[?&]width=/.test(u) ? u : `${u}${u.includes('?') ? '&' : '?'}width=${w || 160}`);
  // only used in the open form (product rows, upsell): eager, so the picture is there when the sheet slides in
  const img = (u, w, px) => (u ? `<img src="${esc(sized(u, w))}" alt="" width="${px || 44}" height="${px || 44}" loading="eager">` : '<span class="bbcod-noimg"></span>');
  const STORE = 'bb_cod_details';
  const P = cfg.product || null;
  const offs = P && Array.isArray(P.offs) ? P.offs.map(Number) : [];

  /* ---------- settings (COD app) with built-in defaults ---------- */
  const T = { title: 'Cash on Delivery', button: 'PLACE ORDER', tip: '🚚 Full address = fast delivery', tipHi: 'पूरा पता लिखें' };
  const FLD = { landmark: { show: true, req: false }, email: { show: false, req: false }, altPhone: { show: false, req: false } };
  const DLV = { def: 0, freeAbove: null, eta: '', codFee: 0, rules: [] }; // rules: [{ states, pins, fee|null, days, cod }]
  const UPS = { minutes: 5, heading: '⚡ ONE-TIME OFFER' };
  const LEADS = { on: false };  // save half-filled forms (COD app: Half-filled forms)
  const GEO = { visits: false }; // count visits by area (COD app: Location insights)
  // COD app: Offers (prepaid.code = the Shopify discount code, '' while it isn't ready)
  const OFF = { pre: { on: false, type: 'fixed', amount: 0, text: '', code: '' }, bump: { on: false, product: 'same', price: 0, text: '', showOn: 'all', products: [] }, down: false, coupon: false };
  let consentOn = false;         // cookie banner on (assets/bb-pixels.js asks; used when that file is missing)
  let payOn = !!cfg.payOnline;
  let etaDays = Number(cfg.etaDays) || 7;
  const etaText = (n) => { const d = new Date(); d.setDate(d.getDate() + (n || etaDays)); return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
  const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

  const F = (n) => form.elements[n];
  let mode = 'product';    // 'product' | 'cart'
  let lines = [];          // [{variant_id, qty, title, sub, image, unit, product_id?, handle?}]
  let box = null, boxBtn = null;
  let variant = null, pack = 1;
  let quote = null, quoteSeq = 0, quoteTimer = 0, quoteState = 'loading';
  let codes = [];          // cart discount codes (applied in the cart)
  let subKey = '';         // one id per form submission: a retry never creates a second order
  let hints = [];          // Shopify's related products: only ranks the server's upsell pool
  let order = null, upsell = null, upsellAdded = false, timer = 0, busy = false;
  let lastFocus = null, curStep = 1, filled = false;
  let tsWidget = null, tsToken = '';
  // Phase 3: the bump is ticked; the chosen add-on product ({ title, unit, variant_id }, from a quote); the server
  // ignored the bump (price above the product's price); the coupon typed ('wait' | 'ok' | 'skip') and its ₹ off;
  // Cash on Delivery or Pay online picked; Pay online forced by the server (high risk); on the way to checkout; the
  // server's last COD answer for an area ({ k: area key, no }), used while the next quote for it loads
  let bump = false, bumpInfo = null, bumpGone = false, bumpAsk = false;
  let coupon = { code: '', st: '' }, couponOff = null, cpOpen = false;
  let payPick = 'cod', forcePay = false, redirecting = false, dnTried = false, payNowOn = false, codAns = null;
  // Phase 4, Partial COD: the COD app's public partial settings; the server's 409 ADVANCE answer (adv: { amount, balance,
  // off, codFee, waived, method, onRefusal, fullOnline, reason, base: the total it was asked for, phone: the mobile number
  // it was asked for); the advance card is the one picked (set by renderSummary); paidHold: the submission key whose
  // advance was paid with Razorpay but not confirmed yet (no second payment for that submission)
  const PART = { on: false, method: 'checkout', everyone: false, everyoneOff: 0, amount: { mode: 'fixed', fixed: 99, pct: 20, max: 299, round: 'nine' }, codFee: 'waive', fullOnline: true, onRefusal: 'refund', rzpKey: '' };
  let adv = null, advOn = false, paidHold = '';
  const held = () => !!paidHold && paidHold === subKey;

  /* ---------- template (COD app: Templates & A/B) ---------- */
  const TPLS = ['sheet', 'steps', 'inline', 'popup', 'dark'];
  let previewTpl = '';
  try {
    const q = new URLSearchParams(location.search).get('codtpl');
    if (q === '0') sessionStorage.removeItem('bb_codtpl');
    else if (TPLS.includes(q)) sessionStorage.setItem('bb_codtpl', q);
    previewTpl = sessionStorage.getItem('bb_codtpl') || '';
  } catch (e) { previewTpl = ''; }
  if (!TPLS.includes(previewTpl)) previewTpl = '';
  let baseTpl = 'sheet', formVersion = '', abId = null; // this visitor's template, A/B version ('A' | 'B' | '') and test id
  let cur = 'sheet';                                    // the template of the form on screen now
  function chooseTemplate(s) {
    const ab = (s && s.ab) || {};
    let t = previewTpl, v = '', id = null;
    if (!t && ab.on === true && TPLS.includes(ab.a) && TPLS.includes(ab.b) && ab.a !== ab.b) {
      id = ab.id == null ? null : ab.id;
      const split = Math.min(90, Math.max(10, Number(ab.split) || 50));
      let st = null;
      try { st = JSON.parse(localStorage.getItem('bb_ab') || 'null'); } catch (e) { st = null; }
      if (!st || st.id !== id || (st.v !== 'A' && st.v !== 'B')) { // a new test: draw again
        st = { id, v: Math.random() * 100 < split ? 'A' : 'B' };
        try { localStorage.setItem('bb_ab', JSON.stringify(st)); } catch (e) { /* private mode */ }
      }
      v = st.v; t = v === 'A' ? ab.a : ab.b;
    }
    if (!t && s && TPLS.includes(s.template)) t = s.template;
    baseTpl = t || 'sheet'; formVersion = v; abId = v ? id : null;
  }
  chooseTemplate(null);
  const tplFor = () => (baseTpl === 'inline' ? 'sheet' : baseTpl); // a popup opening: inline only lives in the buy box
  function applyTpl(t) {
    ['steps', 'popup', 'dark'].forEach((k) => root.classList.toggle(`bbcod--${k}`, t === k));
    root.classList.toggle('is-product', mode === 'product');
    root.classList.remove('is-s2');
  }

  /* ---------- tracking (assets/bb-pixels.js) + form counters on our server ---------- */
  const bbTrack = (name, data) => { try { if (window.bbTrack) window.bbTrack(name, data); } catch (e) { /* never break the form */ } };
  const contents = (ls) => ls.map((l) => ({ id: l.variant_id, pid: l.product_id || (mode === 'product' && P ? P.id : undefined), quantity: l.qty, item_price: l.unit }));
  const post = (path, obj) => { // navigator.sendBeacon (text/plain), else fetch keepalive; best effort
    try {
      const b = JSON.stringify(obj);
      if (!(navigator.sendBeacon && navigator.sendBeacon(`${API}${path}`, b))) fetch(`${API}${path}`, { method: 'POST', body: b, keepalive: true }).catch(() => {});
    } catch (e) { /* counters are best effort */ }
  };
  // the product the form is for: the product page's, or the cart's when it holds one product only ('' = several)
  const formPid = () => {
    if (mode === 'product') return P ? String(P.id) : '';
    const ids = [...new Set(lines.map((l) => String(l.product_id || '')))];
    return ids.length === 1 && /^\d+$/.test(ids[0]) ? ids[0] : '';
  };
  let typed = true; // one 'typed' per form open: each open beacon allows the next one
  const beacon = (kind) => {
    if (kind === 'open') typed = false;
    post('/event', kind === 'open' ? { kind, pid: formPid(), ...(formVersion ? { v: formVersion, ab_id: abId } : {}) } : kind === 'typed' ? { kind, pid: formPid() } : { kind });
  };
  const attrNow = () => { try { return (window.bbAttr && window.bbAttr()) || {}; } catch (e) { return {}; } };
  const consentNow = () => {
    try { if (window.bbConsent) return window.bbConsent(); } catch (e) { /* below */ }
    if (!consentOn) return 'na';
    try { return localStorage.getItem('bb_consent') === 'yes' ? 'yes' : 'no'; } catch (e) { return 'no'; }
  };
  const pageUrl = () => location.href.slice(0, 500);

  /* ---------- open / close ---------- */
  const step = (n) => {
    curStep = n;
    root.querySelectorAll('[data-cod-step]').forEach((s) => s.classList.toggle('is-on', +s.dataset.codStep === n));
    root.querySelectorAll('[data-chip]').forEach((c) => { c.hidden = +c.dataset.chip !== n; });
    if (n !== 1) root.classList.remove('is-s2');
    $('[data-cod-title]').textContent = [T.title, 'Order placed 🎉', 'Thank you!'][n - 1];
    const b = $(`[data-cod-step="${n}"] .bbcod-bd`); if (b) b.scrollTop = 0;
  };
  const newKey = () => { try { return crypto.randomUUID(); } catch (e) { return `k${Date.now()}${Math.random().toString(36).slice(2)}`; } };
  const wide = () => matchMedia('(min-width: 641px)').matches;
  let pushed = false;  // our history entry while the form is open, so the phone's Back button closes it
  let pushed2 = false; // steps template: one more entry for step 2, so Back returns to step 1
  function fresh() { // a new form submission
    order = null; upsell = null; upsellAdded = false; upsellState = ''; busy = false; filled = false;
    bump = false; coupon = { code: '', st: '' }; couponOff = null; cpOpen = false; payPick = 'cod'; forcePay = false; dnTried = false;
    adv = null; advOn = false;
    if (F('coupon')) F('coupon').value = '';
    const r = form.querySelector('input[name="bbcod_pay"][value="cod"]'); if (r) r.checked = true;
    subKey = newKey();
    hideErr();
  }
  const show = () => {
    try { if (!pushed) { history.pushState({ bbcod: 1 }, ''); pushed = true; } } catch (e) { /* no history */ }
    lastFocus = document.activeElement;
    if (inlineForm()) formHome(); // the inline form opens in the sheet (cart), and goes back to the page on close
    fresh();
    cur = tplFor();
    applyTpl(cur);
    step(1);
    setSub(1);
    root.hidden = false;
    pageInert(true);
    H.classList.add('bbcod-open');
    requestAnimationFrame(() => root.classList.add('is-on'));
    prefill();
    renderItems();
    renderSummary();
    requestQuote(0);
    if (quoteWait) quoteWait.then(prefetchPacks);
    loadTurnstile();
    bbTrack('InitiateCheckout', { value: estimate().total, currency: 'INR', contents: contents(lines), form_version: formVersion, template: cur });
    beacon('open');
    idle();
    setTimeout(() => { const f = firstEmpty(); if (f && wide()) f.focus({ preventScroll: true }); else $('.bbcod-x').focus({ preventScroll: true }); }, 60);
  };
  const close = () => {
    if (root.hidden) return;
    if (busy) return; // never hide an order that is being placed (Back while placing: see popstate)
    const n = (pushed ? 1 : 0) + (pushed2 ? 1 : 0); // our history entries still there (Back already took one)
    pushed = false; pushed2 = false;
    if (n) { try { history.go(-n); } catch (e) { /* ignore */ } }
    if (!order) saveLead(); // closed without an order: keep the half-filled details
    clearInterval(timer); clearTimeout(idleT);
    if (upsellState === 'adding') { /* keeps running in the background */ }
    root.classList.remove('is-on');
    H.classList.remove('bbcod-open');
    pageInert(false);
    setTimeout(() => { root.hidden = true; if (inl.on && !inl.host.contains(form)) inlineBack(); }, 220);
    if (order && mode === 'cart') { location.reload(); return; } // cart is empty now: refresh drawer / page
    if (order && inlineForm()) { fresh(); renderSummary(); } // inline: the order is done, the form on the page starts again
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    if (baseTpl === 'inline' && !inl.on) setTimeout(mountInline, 260); // the settings came while the sheet was open
  };

  window.addEventListener('popstate', () => {
    if (!pushed && !pushed2) return;
    const was2 = pushed2;
    if (pushed2) pushed2 = false; else pushed = false;
    if (root.hidden) return;
    if (busy) { // placing the order: Back keeps the form open
      try { history.pushState({ bbcod: was2 ? 2 : 1 }, ''); if (was2) pushed2 = true; else pushed = true; } catch (e) { /* ignore */ }
      return;
    }
    if (was2 && curStep === 1 && sub === 2) { toStep1(); return; }
    close();
  });

  /* inline template: the upsell / thank-you screens open as the full-screen sheet (exactly as before) */
  function overlay() {
    try { if (!pushed) { history.pushState({ bbcod: 1 }, ''); pushed = true; } } catch (e) { /* no history */ }
    lastFocus = document.activeElement;
    applyTpl('sheet');
    root.hidden = false;
    pageInert(true);
    H.classList.add('bbcod-open');
    requestAnimationFrame(() => root.classList.add('is-on'));
  }
  // the page behind the open sheet can't be reached (screen readers, Tab): every branch beside the sheet's is inert while
  // it is open, and only what we made inert goes back
  let inerted = [];
  function pageInert(on) {
    inerted.forEach((el) => { el.inert = false; });
    inerted = [];
    if (!on || !('inert' in HTMLElement.prototype)) return;
    for (let n = root; n.parentElement && n !== document.body; n = n.parentElement) {
      [...n.parentElement.children].forEach((x) => { if (x !== n && !x.inert && !/^(SCRIPT|STYLE|LINK|META|TEMPLATE)$/.test(x.tagName)) { x.inert = true; inerted.push(x); } });
    }
  }

  /* ---------- steps template: step 1 = name + mobile, step 2 = address ---------- */
  let sub = 1;
  const G1 = ['name', 'phone', 'alt_phone', 'email']; // the fields of step 1
  const stepsOn = () => cur === 'steps' && root.contains(form);
  const packName = (n) => `${n} Pack${n > 1 ? 's' : ''}`;
  function setSub(n) {
    sub = stepsOn() && n === 2 ? 2 : 1;
    const two = sub === 2;
    root.classList.toggle('is-s2', two);
    if (curStep === 1) $('[data-cod-title]').textContent = two ? 'Delivery address' : T.title;
    $('[data-cod-bar2]').classList.toggle('is-on', two);
    $('[data-cod-stepl]').textContent = two ? 'Step 2 of 2 · Address' : 'Step 1 of 2 · Your details';
    $('[data-cod-stepr]').textContent = two ? 'Almost done' : 'Next: address';
    if (two) {
      const p = F('phone').value;
      $('[data-cod-fname]').textContent = F('name').value.trim();
      $('[data-cod-fphone]').textContent = `${p.slice(0, 5)} ${p.slice(5)}`;
    }
    const b = $('[data-cod-step="1"] .bbcod-bd'); if (b) b.scrollTop = 0;
    renderSummary();
  }
  function next() { // NEXT: ADDRESS
    normPhone(); normNum('alt_phone');
    let first = null;
    G1.forEach((n) => { const msg = RULES[n](F(n).value || ''); fieldErr(n, msg); if (msg && !first) first = F(n); });
    if (first) { first.focus(); return; }
    saveLead(); // the mobile number is saved as soon as they tap Next
    try { if (!pushed2) { history.pushState({ bbcod: 2 }, ''); pushed2 = true; } } catch (e) { /* no history */ }
    setSub(2);
    setTimeout(() => { const f = firstEmpty(); if (f && wide()) f.focus({ preventScroll: true }); else $('.bbcod-back').focus({ preventScroll: true }); }, 60);
  }
  function toStep1() { // Back / Edit: everything typed is kept
    setSub(1);
    setTimeout(() => { const f = firstEmpty(); if (f && wide()) f.focus({ preventScroll: true }); else $('[data-cod-place]').focus({ preventScroll: true }); }, 60);
  }
  function back() {
    if (busy || sub !== 2) return;
    if (pushed2) { try { history.back(); return; } catch (e) { pushed2 = false; } } // popstate → toStep1
    toStep1();
  }

  /* product page: that product, packs */
  function openProduct(buyBox, btn, want) {
    if (!P || off) return false;
    if (inlineForm() && buyBox === inl.box) { if (!busy) toInline(); return true; } // inline: the sticky bars bring the form into view
    box = buyBox; boxBtn = btn;
    const wv = want && Number(want.variant);
    variant = (wv && P.variants.find((v) => v.id === wv && v.available)) || null;
    if (!variant) {
      const vid = boxVariant(box);
      variant = P.variants.find((v) => v.id === vid) || P.variants.find((v) => v.available) || P.variants[0];
    }
    if (!variant || !variant.available) return false;
    pack = want && Number(want.qty) > 0 ? Math.min(20, Math.floor(Number(want.qty))) : Math.max(1, Number((box && box.qty && box.qty()) || 1));
    mode = 'product';
    setProductLines();
    codes = [];
    related(P.id);
    show();
    return true;
  }
  const boxVariant = (bx) => Number((bx && bx.variantId && bx.variantId()) || (bx && bx.dataset.variantId) || (P.variants[0] && P.variants[0].id));
  function setProductLines() {
    const unit = variant.price / 100;
    const vt = P.variants.length > 1 && variant.title !== 'Default Title' ? variant.title : '';
    lines = [{ variant_id: variant.id, qty: pack, title: P.title, sub: [P.sub, vt].filter(Boolean).join(' • '), image: P.image, unit }];
  }

  /* whole cart */
  async function openCart() {
    if (off) { location.href = `${shopRoot}checkout`; return; }
    if (busy) return;
    let cart;
    try { cart = await (await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } })).json(); } catch (e) { cart = null; }
    if (!cart || !cart.items || !cart.items.length) { location.href = `${shopRoot}cart`; return; }
    if (busy) return; // the inline form is placing an order
    mode = 'cart'; box = null;
    lines = cart.items.map((it) => ({ variant_id: it.variant_id, qty: it.quantity, title: it.product_title, sub: it.variant_title || '', image: it.image || (it.featured_image && it.featured_image.url) || '', unit: it.original_price / 100, product_id: it.product_id, handle: it.handle || '' }));
    codes = (cart.discount_codes || []).filter((d) => d && d.applicable !== false && d.code).map((d) => d.code);
    related(lines[0].product_id);
    show();
  }

  /* ---------- inline template: the form inside the product page buy box, in place of its ORDER NOW ---------- */
  const inl = { on: false, host: null, box: null, seen: false, counted: false, io: null, variant: null, pack: 1 };
  const inlineForm = () => inl.on && inl.host.contains(form);
  const inlTitle = () => (T.title === 'Cash on Delivery' ? 'Order with Cash on Delivery' : T.title); // the card's heading follows the form title
  const formHome = () => { const s2 = root.querySelector('[data-cod-step="2"]'); s2.parentNode.insertBefore(form, s2); };
  function mountInline(vid) { // vid: the variant the page shows (0 = none), else read from the buy box
    if (inl.on || off || baseTpl !== 'inline' || !P || !root.hidden || busy) return;
    const bx = document.querySelector('bb-buy-box');
    const main = bx && bx.querySelector(':scope > .bb-cta');
    if (!main) return;
    const v = P.variants.find((x) => x.id === (vid === undefined ? boxVariant(bx) : vid));
    if (!v || !v.available) return; // sold out: the buy box shows its own button
    const host = document.createElement('div');
    host.className = `bbcod bbcod-inl${root.classList.contains('bbcod--shake') ? ' bbcod--shake' : ''}`;
    host.setAttribute('data-order-anchor', ''); // blocks/bb-buy-box.liquid: the sticky order bars follow this instead of the hidden button
    host.setAttribute('role', 'region');
    host.setAttribute('aria-labelledby', 'bbcod-inl-title');
    host.style.cssText = root.style.cssText; // button colours
    host.innerHTML = `<h2 class="bbcod-inl-hd"><span id="bbcod-inl-title">${esc(inlTitle())}</span><span class="bbcod-chip">💵 Pay when it arrives</span></h2>`;
    main.before(host);
    host.appendChild(form);
    host.addEventListener('click', onClick);
    bx.classList.add('bbcod-inline-on'); // bb-cod.css hides the buy box's button and pack picker: the form's packs replace them
    Object.assign(inl, { on: true, host, box: bx, seen: false, variant: v, pack: Math.max(1, Number((bx.qty && bx.qty()) || 1)) });
    inlineLoad(false);
    // the form counts as opened (open beacon, InitiateCheckout) once it is first scrolled into view
    const seen = () => {
      if (inl.seen || !inl.on) return;
      inl.seen = true;
      if (inl.io) { inl.io.disconnect(); inl.io = null; }
      if (!inlineForm()) return;
      related(P.id);
      loadTurnstile();
      if (quoteWait) quoteWait.then(prefetchPacks);
      if (!inl.counted) { // once per page, also when the form is mounted again (section re-rendered, variant back in stock)
        inl.counted = true;
        bbTrack('InitiateCheckout', { value: estimate().total, currency: 'INR', contents: contents(lines), form_version: formVersion, template: cur });
        beacon('open');
      }
      idle();
    };
    if ('IntersectionObserver' in window) { inl.io = new IntersectionObserver((es) => { if (es.some((x) => x.isIntersecting)) seen(); }, { threshold: 0.25 }); inl.io.observe(host); }
    else seen();
    if (bx.onScroll) bx.onScroll();
  }
  function inlineLoad(withHints) { // the inline form shows this product (again)
    cur = 'inline';
    mode = 'product'; box = inl.box; boxBtn = null;
    variant = inl.variant; pack = inl.pack;
    setProductLines();
    codes = [];
    if (withHints) related(P.id);
    fresh();
    sub = 1;
    form.classList.add('is-on');
    prefill();
    renderItems();
    renderSummary();
    requestQuote(0);
  }
  function inlineBack() { inl.host.appendChild(form); inlineLoad(true); } // after the cart sheet closed
  function unmountInline() {
    if (!inl.on) return;
    if (inl.io) inl.io.disconnect();
    if (inl.host.contains(form)) formHome();
    inl.host.remove();
    const bx = inl.box;
    bx.classList.remove('bbcod-inline-on');
    Object.assign(inl, { on: false, host: null, box: null, io: null });
    if (bx.onScroll) bx.onScroll();
  }
  function syncInline(vid) { // the page's variant picker changed the variant (vid: the new one, 0 = none; else read the buy box)
    if (!P || off || baseTpl !== 'inline') return;
    if (inl.on && !inl.host.isConnected) unmountInline(); // the section was rendered again
    if (!inl.on) { mountInline(vid); return; }
    if (!inlineForm() || busy) return;
    const v = P.variants.find((x) => x.id === (vid === undefined ? boxVariant(inl.box) : vid));
    if (!v || !v.available) { unmountInline(); return; }
    if (v.id === variant.id) return;
    inl.variant = variant = v;
    setProductLines(); renderItems(); requestQuote();
  }
  function inlinePack() { // keep the buy box (sticky bar price, quantity) on the form's pack
    inl.pack = pack;
    const r = inl.box.querySelector(`.bb-bundles input[value="${pack}"]`);
    if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  function toInline() { // sticky order bars, ?codopen=1, ?cod=: scroll to the form, focus the first empty field
    const smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { inl.host.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' }); } catch (e) { inl.host.scrollIntoView(); }
    setTimeout(() => { const f = firstEmpty() || $('[data-cod-place]'); try { f.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }, smooth ? 400 : 0);
  }
  // Horizon's variant picker fires shopify:product:select; its promise resolves once the page has the new variant
  // (detail.resource, null for a combination that doesn't exist) and rejects when a newer pick replaced it
  document.addEventListener('shopify:product:select', (e) => {
    const t = e.target, bx = document.querySelector('bb-buy-box');
    if (!bx || !(t instanceof Element) || t.closest('product-card, dialog') || !(bx.closest('.shopify-section') || document).contains(t)) return; // product cards and Quick Add pick their own product
    Promise.resolve(e.promise).then((r) => {
      const d = r && r.detail;
      const vid = d && 'resource' in d ? Number(d.resource && d.resource.id) || 0 : undefined;
      setTimeout(() => syncInline(vid), 0);
    }, () => {});
  });
  document.addEventListener('variant:update', () => setTimeout(syncInline, 0)); // older variant pickers

  /* ---------- rendering ---------- */
  const offFor = (n) => (n === 2 ? offs[0] || 0 : n >= 3 ? offs[1] || 0 : 0);
  // the product's delivery charge (an area rule's charge when it is higher), FREE when the order (after the pack discount) reaches "free above"
  const feeFor = (net) => {
    const a = localArea();
    const f = a && a.fee != null ? Math.max(a.fee, P && P.ownFee != null ? P.ownFee : 0) : Number(P && P.fee) || 0;
    return f > 0 && DLV.freeAbove != null && net >= DLV.freeAbove ? 0 : f;
  };
  const hintFor = (v, n) => (P && v ? feeFor((v.price / 100) * n - offFor(n)) : 0);
  function renderItems() {
    const items = $('[data-cod-items]'), packs = $('[data-cod-packs]');
    if (mode === 'product') {
      const l = lines[0];
      items.innerHTML = `<div class="bbcod-prod">${img(l.image, 100)}<div><b>${esc(l.title)}</b>${l.sub ? `<small>${esc(l.sub)}</small>` : ''}</div><span></span></div>`;
      const unit = variant.price / 100;
      const opts = [1, 2, 3];
      if (pack > 3) opts.push(pack);
      packs.innerHTML = opts.map((n) => {
        const o = offFor(n);
        return `<button type="button" data-cod-pack="${n}"${n === pack ? ' class="is-on" aria-pressed="true"' : ' aria-pressed="false"'}>${packName(n)}<b>${inr(unit * n - o)}</b>${o ? `<em>SAVE ${inr(o)}</em>` : ''}</button>`;
      }).join('');
    } else {
      packs.innerHTML = '';
      items.innerHTML = lines.map((l) => `<div class="bbcod-prod">${img(l.image, 100)}<div><b>${esc(l.title)}</b><small>${l.sub ? `${esc(l.sub)} • ` : ''}Qty ${l.qty}</small></div><span>${inr(l.unit * l.qty)}</span></div>`).join('');
    }
  }
  function estimate() { // until the server's quote is here (same shape: items, delivery, cod_fee, total)
    const sub2 = lines.reduce((s, l) => s + l.unit * l.qty, 0);
    const off2 = mode === 'product' ? offFor(pack) : 0;
    const add = bumpSent() ? OFF.bump.price : 0;
    const fee = mode === 'product' && P ? feeFor(sub2 - off2 + add) : null;
    const cod = noCod() ? 0 : DLV.codFee;
    const items = mode === 'product' ? (lines.length ? [{ title: lines[0].title, qty: pack, total: sub2 - off2 }] : []) : lines.map((l) => ({ title: l.title, qty: l.qty, total: l.unit * l.qty }));
    if (add) items.push({ addon: true, title: bumpInfo ? bumpInfo.title : '', qty: 1, total: add });
    return { items, subtotal: sub2 + add, discount: off2, delivery: fee, cod_fee: cod, total: sub2 - off2 + add + (fee || 0) + cod, estimate: true };
  }

  /* ---------- Phase 3: delivery rules, order bump, coupon, prepaid ---------- */
  const stateName = (code) => { const o = code ? [...F('state').options].find((x) => x.value === code) : null; return o ? o.text : ''; };
  const okPin = (p) => /^[1-9]\d{5}$/.test(p || '');
  // the area rules for a pincode + state code (server = authority): pincode rules first, then state rules, in list order;
  // the first charge and the first days that are set win, and any "No COD" rule switches COD off
  function localArea(pin, st) {
    if (!DLV.rules.length) return null;
    const p = pin === undefined ? F('pincode').value : pin, s = st === undefined ? F('state').value : st;
    const m = [...DLV.rules.filter((r) => okPin(p) && r.pins.some((x) => p.startsWith(x.replace(/x+$/i, '')))), ...DLV.rules.filter((r) => s && r.states.includes(s))];
    if (!m.length) return null;
    const f = m.find((r) => r.fee != null), d = m.find((r) => r.days);
    return { fee: f ? f.fee : null, days: d ? d.days : '', cod: !m.some((r) => r.cod === false) };
  }
  const area = () => (quote && quote.area !== undefined ? quote.area : localArea()); // a quote is always for the pincode + state on screen
  const noCod = () => {
    if (quote && typeof quote.cod_allowed === 'boolean') return !quote.cod_allowed;
    if (codAns && codAns.k === JSON.stringify(areaNow())) return codAns.no;
    const a = localArea();
    return !!a && a.cod === false;
  };
  // a no-COD area where the quote still allows COD: Partial COD takes it there with an advance (/order: 409 ADVANCE)
  const advArea = () => !!(quote && quote.area && quote.area.cod === false) && !noCod();
  const daysOf = (t) => String(t || '').replace(/\s*days?\s*$/i, '').trim(); // "7–10" (from "7–10" or "7–10 days")
  const maxDay = (t) => { const n = String(t || '').match(/\d+/g); return n ? Math.min(60, Math.max(...n.map(Number))) : 0; };
  const areaParams = (pin, st) => ({ ...(okPin(pin) ? { pincode: pin } : {}), ...(st ? { state: st } : {}) });
  const areaNow = () => areaParams(F('pincode').value, F('state').value);
  const codOnlyItems = () => (mode === 'product' ? !!(P && P.codOnly) : !!(quote && quote.pay_online === false && payOn));
  // Pay online is how this order gets paid: a no-COD area, high risk (409), or Pay online picked in the prepaid choice;
  // once the server asked for an advance (409 ADVANCE) only when "Pay in full online" is picked
  const payOnlineNow = () => (adv ? payPick === 'online' && fullOk() : noCod() || forcePay || (payPick === 'online' && preOk() && !codOnlyItems()));
  // order bump: product mode when it is on for this product; cart mode only for a chosen add-on product. Cash on
  // Delivery only: a checkout link can't carry the bump price, so it is hidden (and unticked) while paying online
  const bumpProd = () => (OFF.bump.product === 'same' ? 'same' : /^\d+$/.test(OFF.bump.product) ? OFF.bump.product : '');
  function bumpShown() {
    const b = OFF.bump, bp = bumpProd();
    if (!b.on || bumpGone || !(b.price >= 1) || !bp || !lines.length || payOnlineNow()) return false;
    if (mode !== 'product') return bp !== 'same';
    if (!P || !(b.showOn === 'all' || b.products.includes(String(P.id)))) return false;
    return bp !== 'same' || (!!variant && b.price <= variant.price / 100); // the server ignores a bump above the pack's price
  }
  const bumpSent = () => bump && bumpShown();
  // the bump came or went without a tap (Pay online picked or forced): price the order again when the quote disagrees
  const syncBump = () => { if (quote && (quote.items || []).some((x) => x.addon) !== bumpSent()) requestQuote(0); else renderSummary(); };
  const bumpNormal = () => (bumpProd() === 'same' ? (variant ? variant.price / 100 : 0) : bumpInfo ? bumpInfo.unit : 0);
  const addonLabel = (it) => (bumpProd() === 'same' ? 'Extra pack (add-on)' : /\(add-on\)\s*$/i.test(it.title || '') ? it.title : `${it.title || (bumpInfo && bumpInfo.title) || 'Extra item'} (add-on)`);
  function bumpPeek() { // a chosen add-on product: its title and normal price come with a quote that has the bump
    if (bumpAsk || bumpInfo || !quote || bumpProd() === 'same' || !bumpShown()) return;
    bumpAsk = true; // once per page
    fetchQuote(payloadLines(), codesNow(), feeHint(), { ...areaNow(), source: mode, bump: true }).then((d) => {
      if (!(d.ok && d.quote)) return;
      if (!noteAddon(d.quote)) bumpGone = true;
      if (!root.hidden || inlineForm()) renderSummary();
    }).catch(() => {});
  }
  function noteAddon(q) { // unit: the product's normal price (the add-on line's compare; its own unit is the bump price)
    const ad = (q.items || []).find((x) => x.addon);
    if (ad && bumpProd() !== 'same') bumpInfo = { title: ad.title || '', unit: Number(ad.compare) || 0, variant_id: ad.variant_id };
    return !!ad;
  }
  // coupon: every quote is priced with and without it until Remove (the server skips a code that can't be used); it
  // goes with the order only while it lowers the price, else the quote on screen is the one without it
  const sameCode = (a, b) => String(a).toLowerCase() === String(b).toLowerCase();
  const withCoupon = () => (coupon.code && !codes.some((c) => sameCode(c, coupon.code)) ? [...codes, coupon.code] : codes.slice());
  const couponOk = () => !!coupon.code && coupon.st === 'ok';
  const codesNow = () => (coupon.code && !couponOk() ? codes.filter((c) => !sameCode(c, coupon.code)) : withCoupon());
  // cart mode: a code applied in the cart (and used by the quote) goes in the checkout link, so the PREPAID code isn't
  // offered then (a link carries one code, and only Shopify knows that code's value)
  const cartCode = () => {
    if (mode !== 'cart') return '';
    return (quote ? quote.codes || [] : codes).find((c) => codes.some((x) => sameCode(x, c)) && !(coupon.code && sameCode(c, coupon.code))) || '';
  };
  const preOk = () => OFF.pre.on && !!OFF.pre.code && OFF.pre.amount > 0 && !cartCode();
  const preSave = () => (OFF.pre.type === 'pct' ? `${OFF.pre.amount}%` : inr(OFF.pre.amount));
  // the Pay online amount: no COD fee, and the one code the checkout link carries: a code from the cart (already in the
  // quote), else the PREPAID code (₹ or % of the items after discounts) or the coupon, whichever saves more; the code
  // left out (drop) is added back
  function online(q) {
    const base = r2(q.total - (Number(q.cod_fee) || 0)); // checkout with every code of the quote
    const cp = couponOk() ? coupon.code : '', cOff = cp ? couponOff || 0 : 0, cc = cartCode();
    if (cc) return { off: 0, code: cc, drop: cp, total: r2(base + cOff) };
    if (!preOk()) return { off: 0, code: cp, drop: '', total: base };
    const items = Math.max(0, base - (q.delivery || 0) + cOff);
    const off = OFF.pre.type === 'pct' ? r2((items * OFF.pre.amount) / 100) : Math.min(items, OFF.pre.amount);
    if (cp && cOff >= off) return { off: 0, code: cp, drop: '', total: base }; // the coupon saves more: it goes instead
    return { off, code: OFF.pre.code, drop: cp, total: r2(base + cOff - off) };
  }

  /* ---------- Phase 4: Partial COD (a small advance now, the rest on delivery) ---------- */
  // the advance for an order total, the server's advanceFor rules (its answer always wins): ₹ or % of the order, capped
  // at the max and at half the order; % rounded up to an amount ending in 9 or to the nearest ₹10; at least ₹1;
  // 0 = no advance (it would be the whole order: pay online instead)
  function advFor(total) {
    const a = PART.amount, t = Number(total) || 0;
    let x = a.mode === 'pct' ? Math.ceil((t * a.pct) / 100) : a.fixed;
    x = Math.min(x, a.max, Math.floor(t * 0.5));
    if (a.mode === 'pct') x = a.round === 'ten' ? Math.round(x / 10) * 10 : x + ((19 - (x % 10)) % 10);
    x = Math.max(1, x);
    return x >= t - 1 ? 0 : x;
  }
  // "Pay in full online" next to an advance the server asked for (the normal Pay online path)
  const fullOk = () => (adv ? adv.fullOnline : PART.fullOnline) && payOn && !codOnlyItems();
  // what the buyer owes with an advance (the server's advanceQuote): the total without the COD fee when it is waived
  // (waived: the server's word after a 409 ADVANCE that had a fee, else the settings; never without a fee)
  function advDue(q) {
    const fee = Number(q.cod_fee) || 0;
    const waived = fee > 0 && (adv && adv.codFee > 0 ? adv.waived : PART.codFee === 'waive');
    return { fee, waived, due: r2((Number(q.total) || 0) - (waived ? fee : 0)) };
  }
  // everyone mode: the advance as a third card, while Cash on Delivery is offered for this order
  const advOptOk = (q) => PART.on && PART.everyone && !adv && !forcePay && !noCod() && !codOnlyItems() && advFor(advDue(q).due) > 0;
  // the advance numbers for the quote on screen: the server's while the total is the one it was asked for, else worked
  // out the same way (POST /advance prices it again). fee: the COD fee; waived: not charged with an advance; off: the
  // everyone-mode ₹ off, never leaving less than ₹1 to pay on delivery (none when the server asked for the advance)
  function advNums(q) {
    if (adv && Math.abs(adv.base - q.total) < 0.01) return { amount: adv.amount, balance: adv.balance, off: adv.off, fee: adv.codFee, waived: adv.waived };
    const { fee, waived, due } = advDue(q), amount = advFor(due);
    if (!amount) return adv ? { amount: adv.amount, balance: adv.balance, off: adv.off, fee: adv.codFee, waived } : null;
    const off = adv ? 0 : Math.max(0, Math.min(PART.everyoneOff, Math.floor(due - amount - 1)));
    return { amount, balance: Math.max(0, r2(due - amount - off)), off, fee, waived };
  }
  const nv = (v, d) => (typeof v === 'number' && Number.isFinite(v) && v >= 0 ? v : d); // a ₹ amount from the server, else d
  // the note under the cards: why (only when the server asked) and what happens to the advance on a refusal
  function advNote(n) {
    const a = inr(n);
    const why = adv ? `${adv.reason === 'area' || adv.reason === 'pin' ? 'Your pincode' : 'This order'} needs a ${a} advance for Cash on Delivery. ` : '';
    return why + ((adv ? adv.onRefusal : PART.onRefusal) === 'keep'
      ? `If the order is cancelled, you get ${a} back (in 5–7 days). If you refuse or return the parcel, ${a} is kept as the delivery charge.`
      : `If the order is cancelled or the parcel is returned, you get ${a} back (in 5–7 days).`);
  }
  const advMethod = () => (adv ? adv.method : PART.method);
  // Razorpay checkout.js, loaded once (only for the razorpay method)
  let rzpP = null;
  const loadRzp = () => rzpP || (rzpP = new Promise((ok, no) => {
    if (window.Razorpay) { ok(); return; }
    const s = document.createElement('script');
    s.src = 'https://checkout.razorpay.com/v1/checkout.js';
    s.async = true;
    const fail = () => { rzpP = null; s.remove(); no(new Error('razorpay')); }; // the next tap tries again
    s.onload = () => (window.Razorpay ? ok() : fail());
    s.onerror = fail;
    document.head.appendChild(s);
  }));
  function linesHtml(q, payNow, on, a, ad) { // the lines box (mockup s-lines), in the order of the approved phones; ad: the advance picked
    const row = (l, v, c) => `<div${c ? ` class="${c}"` : ''}><span>${esc(l)}</span><span>${v}</span></div>`;
    const amt = (it) => Number(it.total != null ? it.total : it.unit * it.qty) || 0;
    const items = q.items || [], adds = items.filter((it) => it.addon);
    const fee = Number(q.cod_fee) || 0, del = q.delivery;
    const cOff = couponOk() ? couponOff || 0 : 0;
    const net = q.total - (del || 0) - fee - adds.reduce((s, it) => s + amt(it), 0) + cOff; // the products after their offers
    let out = '';
    if (mode === 'product') out += row(`${lines[0].title} · ${packName(pack)}`, inr(net));
    else {
      let left = net;
      items.filter((it) => !it.addon).forEach((it) => { out += row(`${it.title} · Qty ${it.qty}`, inr(amt(it))); left -= amt(it); });
      if (left < -0.5) out += row('Discount', `−${inr(-left)}`, 'is-g'); else if (left > 0.5) out += row('Taxes', inr(left));
    }
    adds.forEach((it) => { out += row(addonLabel(it), inr(amt(it))); });
    if (couponOk() && !(payNow && on.drop)) out += row(`Coupon ${coupon.code}`, couponOff ? `−${inr(couponOff)}` : 'applied', 'is-g');
    if (payNow && on.off > 0) out += row('Pay online discount', `−${inr(on.off)}`, 'is-g');
    const st = a ? stateName(F('state').value) : '';
    if (del == null) out += row('Delivery', 'calculating…'); // free delivery has no row (approved phone 1)
    else if (del > 0) out += row(`Delivery${st ? ` (${st})` : ''}`, inr(del));
    if (!payNow && fee > 0 && !(ad && ad.waived)) out += row('COD fee', inr(fee));
    if (ad) { // the advance: what is paid now and what on delivery
      if (ad.off > 0) out += row('Advance discount', `−${inr(ad.off)}`, 'is-g');
      return out + row('Advance (pay now)', inr(ad.amount)) + row('Pay on delivery', inr(ad.balance), 'is-t');
    }
    return out + row(payNow ? 'Pay now' : 'Pay on delivery', inr(payNow ? on.total : q.total), 'is-t');
  }
  let saidCp = '', saidNc = ''; // the last coupon / no-COD text announced
  // bump, coupon, no-COD box and the payment cards (show: the cards offered, pick: the one picked, ad: the advance picked)
  function renderOffers(q, nc, on, cards, payNow, show, pick, ad) {
    const bx = $('[data-cod-bump]');
    if (bx) {
      const shown = bumpShown();
      if (!shown) bump = false;
      bx.hidden = !shown;
      if (shown) {
        const n = bumpNormal(), pr = OFF.bump.price;
        bx.setAttribute('aria-checked', bump ? 'true' : 'false');
        $('[data-cod-bump-text]').textContent = OFF.bump.text || `Add 1 more for just ${inr(pr)}`;
        $('[data-cod-bump-sub]').innerHTML = n > pr ? `Normal price <s>${inr(n)}</s> · save ${inr(n - pr)} · same delivery` : 'Same delivery';
        bumpPeek();
      }
    }
    const cpl = $('[data-cod-cpl]'), cp = $('[data-cod-cp]'), ok = $('[data-cod-cpok]');
    if (cpl) {
      cpl.hidden = !OFF.coupon || cpOpen;
      cp.hidden = !OFF.coupon || !cpOpen;
      $('[data-cod-cpapply]').disabled = coupon.st === 'wait';
      const st = OFF.coupon && coupon.code ? coupon.st : '';
      const drop = st === 'ok' && payNow && !!on.drop; // Pay online: the checkout link carries another code
      ok.hidden = st !== 'ok' && st !== 'skip';
      ok.classList.toggle('is-bad', st === 'skip' || drop);
      $('span', ok).textContent = drop ? `${coupon.code} isn't used with Pay online.` : st === 'ok' ? `${coupon.code} applied${couponOff ? `: ${inr(couponOff)} off` : ''}` : 'This code can\'t be used for this order.';
      $('[data-cod-cprm]').hidden = st !== 'ok';
      const said = ok.hidden ? '' : $('span', ok).textContent;
      if (said && said !== saidCp) say(said);
      saidCp = said;
    }
    const nb = $('[data-cod-nocod]');
    if (nb) {
      nb.hidden = !nc || !!adv; // an advance asked for in a no-COD area: the note under the cards says it
      if (!nb.hidden) {
        const pin = F('pincode').value, a = area(), days = daysOf(a && a.days ? a.days : DLV.eta);
        $('span', nb).textContent = `Cash on Delivery isn't available for ${okPin(pin) ? pin : 'this area'}. ${on.off > 0 ? `Pay online and save ${preSave()}.` : 'Pay online.'}${days ? ` Delivery in ${days} days.` : ''}`;
      }
      const said = nb.hidden ? '' : $('span', nb).textContent;
      if (said && said !== saidNc) say(said);
      saidNc = said;
    }
    const pc = $('[data-cod-pay]');
    if (pc) {
      pc.hidden = !cards;
      if (cards) {
        const fee = Number(q.cod_fee) || 0, save = r2(q.total - on.total);
        pc.querySelectorAll('label').forEach((l) => {
          const i = l.querySelector('input'), sh = !!show[i.value];
          l.hidden = !sh; i.disabled = !sh; i.checked = sh && i.value === pick;
          l.classList.toggle('is-on', i.checked);
        });
        $('[data-cod-pay-sub]').textContent = fee > 0 ? `Pay when it arrives · incl. ${inr(fee)} COD fee` : 'Pay when it arrives';
        $('[data-cod-pay-cod]').textContent = inr(q.total);
        $('[data-cod-pay-onsub]').textContent = `UPI · cards · net banking${fee > 0 ? ' · no COD fee' : ''}`;
        if (adv) { // next to the advance the server asked for (approved buyer screen 1)
          $('[data-cod-pay-text]').textContent = `Pay in full online · ${inr(on.total)}`;
          $('[data-cod-pay-on]').innerHTML = save >= 1 ? `<em>SAVE ${inr(save)}</em>` : '';
        } else {
          // the "save" text only while the PREPAID code is what Pay online gets (not a coupon instead, none dropped)
          $('[data-cod-pay-text]').textContent = on.off > 0 && !on.drop ? OFF.pre.text || `Pay online & save ${preSave()}` : 'Pay online';
          $('[data-cod-pay-on]').innerHTML = `${inr(on.total)}${save >= 1 ? `<em>SAVE ${inr(save)}</em>` : ''}`;
        }
        const x = show.adv ? ad || advNums(q) : null; // the advance card's numbers, also while another card is picked
        if (x) {
          const feeTxt = x.fee > 0 ? (x.waived ? ' · no COD fee' : ` · COD fee ${inr(x.fee)}`) : '';
          const split = `Pay ${inr(x.amount)} now · ${inr(x.balance)} on delivery`;
          const sv = r2(q.total - x.amount - x.balance); // the COD fee waived + the everyone-mode ₹ off
          $('[data-cod-adv-text]').textContent = !adv && x.off > 0 ? `Pay ${inr(x.amount)} now · ${inr(x.off)} OFF` : split;
          $('[data-cod-adv-sub]').textContent = !adv && x.off > 0 ? 'Rest on delivery' : `Advance by UPI or card${feeTxt}`;
          $('[data-cod-adv-amt]').innerHTML = adv ? '' : `${inr(x.amount + x.balance)}${sv >= 1 ? `<em>SAVE ${inr(sv)}</em>` : ''}`;
        }
      }
    }
    const an = $('[data-cod-advnote]');
    if (an) { // forced: always under the cards; everyone mode: once the advance card is picked (the refund rule before ordering)
      const x = cards && show.adv && (adv || ad) ? ad || advNums(q) : null;
      an.hidden = !x;
      if (x) an.textContent = advNote(x.amount);
    }
  }
  function renderSummary() {
    const q = quote || estimate();
    const two = stepsOn() && sub === 2, s1 = stepsOn() && sub === 1;
    const card = inlineForm(); // the product page card (mockup "On the product page"): no one-line summary, small line or pay-online link
    const nc = noCod(), a = area(), on = online(q);
    // the payment cards: Cash on Delivery, Pay online (the prepaid choice) and the advance (everyone mode); after a 409
    // ADVANCE only the advance and "Pay in full online"
    const opt = advOptOk(q);
    const show = adv ? { cod: false, online: fullOk(), adv: true } : { cod: true, online: preOk(), adv: opt };
    const cards = !!$('[data-cod-pay]') && !s1 && (!!adv || ((preOk() || opt) && !nc && !forcePay && !codOnlyItems()));
    const pick = adv ? (payPick === 'online' && show.online ? 'online' : 'adv') : show[payPick] ? payPick : 'cod';
    const payNow = (nc && !adv) || forcePay || (cards && pick === 'online');
    const ad = cards && pick === 'adv' ? advNums(q) : null;
    renderOffers(q, nc, on, cards, payNow, show, pick, ad);
    payNowOn = payNow && !s1;
    advOn = !!ad;
    const fee = Number(q.cod_fee) || 0;
    // the lines box: bump, coupon, an area charge, no COD, or the COD fee (the prepaid choice already shows that one)
    const linesOn = bumpSent() || couponOk() || !!(a && a.fee > 0) || nc || forcePay || (fee > 0 && !cards);
    const sm = $('[data-cod-sum]');
    sm.classList.toggle('is-lines', linesOn);
    if (linesOn) sm.innerHTML = linesHtml(q, payNow, on, a, ad);
    else {
      const dl = q.delivery == null ? 'Delivery calculating…' : q.delivery > 0 ? `Delivery ${inr(q.delivery)}` : 'Delivery FREE';
      sm.innerHTML = `<span>${two && mode === 'product' ? `${packName(pack)} · ` : ''}Pay on delivery<small>${q.discount > 0 ? `You save ${inr(q.discount)} • ` : ''}${dl}</small></span><b>${inr(q.total)}</b>`;
    }
    sm.hidden = !linesOn && (card || cards); // the prepaid choice carries both totals
    const b = $('[data-cod-place]');
    if (!busy && !redirecting && !held()) {
      const green = payNow && !s1 && !(quoteState === 'error' && !quote);
      b.classList.toggle('is-green', green || (!!ad && !s1));
      if (s1) { b.disabled = false; b.innerHTML = 'NEXT: ADDRESS<small>Takes 20 seconds</small>'; }
      else if (quoteState === 'error' && !quote) { b.disabled = false; b.innerHTML = 'Couldn\'t load the price – tap to retry<small>Check your internet connection</small>'; }
      else if (ad) { b.disabled = false; b.innerHTML = `PAY ${inr(ad.amount)} NOW<small>Rest ${inr(ad.balance)} when the parcel arrives</small>`; }
      else if (green) { b.disabled = false; b.innerHTML = `PAY ONLINE · ${inr(on.total)}${card ? '' : `<small>${cards && pick === 'online' && on.code ? 'Secure Shopify checkout • discount already applied' : 'Secure Shopify checkout'}</small>`}`; }
      else { b.disabled = false; b.innerHTML = `${esc(T.button)} · ${inr(q.total)}${card ? '' : '<small>Cash on Delivery • ₹0 to pay now</small>'}`; }
    }
    const note = $('[data-cod-codes]');
    if (note) { const sk = ((quote && quote.codes_skipped) || []).filter((c) => !coupon.code || !sameCode(c, coupon.code)); note.hidden = !sk.length; note.textContent = sk.length ? `Code ${sk.join(', ')} can't be used with Cash on Delivery for this order.` : ''; }
    const codOnly = (P && mode === 'product' && P.codOnly) || (quote && quote.pay_online === false);
    // the plain "or pay online" link: only while prepaid is off (the choice or the green button replace it)
    $('[data-cod-payonline]').hidden = !payOn || preOk() || !!codOnly || two || card || payNow || !!adv;
    renderPin();
  }

  /* ---------- server ---------- */
  async function api(path, body, timeoutMs) {
    const ctl = new AbortController();
    const t = setTimeout(() => ctl.abort(), timeoutMs || 20000);
    try {
      const r = await fetch(API + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: ctl.signal } : { signal: ctl.signal });
      const d = await r.json().catch(() => ({ ok: false, error: 'Something went wrong. Please try again.' }));
      d.status = r.status;
      return d;
    } catch (e) {
      return { ok: false, status: 0, error: 'No internet connection? Please check and try again.' };
    } finally { clearTimeout(t); }
  }
  const payloadLines = () => lines.map((l) => ({ variant_id: l.variant_id, qty: l.qty }));
  const feeHint = () => (mode === 'product' && P ? hintFor(variant, pack) : 0);
  /* prices: kept for 2 minutes and fetched ahead (page load, finger on ORDER NOW, the other packs) so the form opens priced */
  // x: { pincode?, state? } (the area rules), source ('cart' | 'product', default product: the bump rules) and bump: true (Phase 3)
  const qCache = new Map();
  const srcOf = (x) => (x && x.source === 'cart' ? 'cart' : 'product');
  const qKey = (ls, cs, x) => JSON.stringify([ls.map((l) => [l.variant_id, l.qty]), cs || [], (x && x.pincode) || '', (x && x.state) || '', srcOf(x), !!(x && x.bump)]);
  function fetchQuote(ls, cs, hint, x) {
    const k = qKey(ls, cs, x), hit = qCache.get(k);
    if (hit && Date.now() - hit.at < 110000) return hit.p;
    const p = api('/quote', { lines: ls, discount_codes: cs, delivery_hint: hint, ...(x || {}), source: srcOf(x) }, 12000).then((d) => { if (!(d.ok && d.quote)) qCache.delete(k); return d; });
    qCache.set(k, { p, at: Date.now() });
    return p;
  }
  let quoteWait = null, areaKey = '';
  function requestQuote(delay, tries, again) { // again: a second pricing because the bump came or went with the quote
    clearTimeout(quoteTimer);
    quote = null; quoteState = 'loading';
    const seq = ++quoteSeq;
    const cp = coupon.code; // typed in the coupon box
    const ls = payloadLines(), cs = cp ? withCoupon() : codes.slice(), ar = areaNow();
    const x = { ...ar, source: mode, ...(bumpSent() ? { bump: true } : {}) };
    areaKey = JSON.stringify(ar);
    const hit = qCache.get(qKey(ls, cs, x));
    let release;
    quoteWait = new Promise((r) => { release = r; });
    const run = async () => {
      // with a coupon: the same quote without it as well (usually cached), for "₹<off> off"
      const [d, base] = await Promise.all([fetchQuote(ls, cs, feeHint(), x), cp ? fetchQuote(ls, cs.filter((c) => !sameCode(c, cp)), feeHint(), x) : null]);
      if (seq !== quoteSeq) return;
      if (d.ok && d.quote) {
        quote = d.quote; quoteState = 'ok';
        if (cp && coupon.code === cp) {
          const used = (quote.codes || []).some((c) => sameCode(c, cp)) && !(quote.codes_skipped || []).some((c) => sameCode(c, cp));
          const b = base && base.ok && base.quote ? base.quote : null;
          const off = b ? r2(b.total - quote.total) : 0; // what the code takes off the amount to pay
          coupon.st = used && (!b || off > 0) ? 'ok' : 'skip';
          couponOff = coupon.st === 'ok' && off > 0 ? off : null;
          if (coupon.st === 'skip' && b) quote = b; // not used, or it doesn't lower the price: the order goes without it
        }
        if (typeof quote.cod_allowed === 'boolean') codAns = { k: areaKey, no: !quote.cod_allowed };
        const add = !!x.bump && noteAddon(quote);
        if (x.bump && !add) { bump = false; bumpGone = true; } // the server ignored the bump
        else if (add !== bumpSent() && !again) { requestQuote(0, 0, true); quoteWait.then(release); return; } // e.g. no COD here after all
        renderSummary(); release(); return;
      }
      if (coupon.st === 'wait') coupon.st = '';
      if (d.status === 409 || d.status === 400) { quoteState = 'error'; renderSummary(); showErr(d.error); release(); return; }
      // brief network / busy: try again; whoever waits for this quote waits for the retry (not a false "couldn't load")
      if ((tries || 0) < 2) { requestQuote(1500 * ((tries || 0) + 1), (tries || 0) + 1, again); quoteWait.then(release); return; }
      quoteState = 'error'; renderSummary(); release();
    };
    renderSummary();
    if (hit) run(); else quoteTimer = setTimeout(run, delay == null ? 150 : delay);
  }
  // the quote on screen, waiting (at most ms) through retries and newer requests (the pack or pincode changed meanwhile)
  async function waitQuote(ms) {
    const until = Date.now() + ms;
    while (!quote && quoteState === 'loading' && Date.now() < until) await Promise.race([quoteWait, new Promise((r) => setTimeout(r, 400))]);
    return quote;
  }
  // the pincode or state changed: a new quote (the area rules), else just the screen
  function areaChanged(delay) {
    if (!lines.length || busy || (root.hidden && !inlineForm())) return;
    if (JSON.stringify(areaNow()) === areaKey) { renderSummary(); return; }
    if (adv && (adv.reason === 'area' || adv.reason === 'pin')) { adv = null; payPick = 'cod'; } // asked for that pincode: /order decides again
    requestQuote(delay);
  }
  function prefetchPacks() { // the other packs, one after another, while the shopper fills the form
    if (mode !== 'product' || !variant) return;
    const ar = areaNow();
    [1, 2, 3].filter((n) => n !== pack).reduce((chain, n) => chain.then(() => fetchQuote([{ variant_id: variant.id, qty: n }], [], hintFor(variant, n), ar)), Promise.resolve()).catch(() => {});
  }

  async function related(productId) {
    hints = [];
    if (!productId) return;
    try {
      const r = await fetch(`${shopRoot}recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=8&intent=related`);
      if (r.ok) hints = ((await r.json()).products || []).filter((p) => p.available).map((p) => p.id);
    } catch (e) { /* the server picks without hints */ }
  }

  /* ---------- pincode ---------- */
  let pinSeq = 0, pinInfo = null, pinMiss = ''; // pinInfo: { pin, city, state } from /pin; pinMiss: a pincode /pin didn't know
  const PIN_MISS = 'Pincode not found — please type your city';
  async function onPin() {
    const el = F('pincode');
    el.value = el.value.replace(/\D/g, '').slice(0, 6);
    const seq = ++pinSeq;
    pinMiss = '';
    if (!okPin(el.value)) { pinInfo = null; renderPin(); areaChanged(600); return; }
    clearFieldErr('pincode');
    areaChanged(600); // waits a moment for the state from /pin
    const d = await api(`/pin/${el.value}`, null, 6000);
    if (seq !== pinSeq) return;
    if (!d.ok) { pinInfo = null; pinMiss = el.value; renderPin(); say(PIN_MISS); return; } // the city is typed by hand
    const city = F('city'), st = F('state');
    if (!city.value || city.dataset.auto) { city.value = d.city || ''; city.dataset.auto = '1'; clearFieldErr('city'); }
    if (d.state_code && (!st.value || st.dataset.auto)) { st.value = d.state_code; st.dataset.auto = '1'; clearFieldErr('state'); }
    pinInfo = { pin: el.value, city: d.city, state: d.state };
    areaChanged(0);
    renderPin();
    const ok = $('[data-cod-pinok]');
    if (ok.classList.contains('is-on')) say(ok.textContent);
  }
  // "📍 City, State • ✅ COD available • by <date>" (+ " (7–10 days)" with an area's days); hidden in a no-COD area (the red
  // box says it); "COD with a small advance" in a no-COD area where Partial COD takes COD with an advance
  function renderPin() {
    const ok = $('[data-cod-pinok]');
    const miss = !!pinMiss && pinMiss === F('pincode').value;
    ok.classList.toggle('is-miss', miss);
    if (miss) { ok.textContent = PIN_MISS; ok.classList.add('is-on'); return; }
    if (!pinInfo || pinInfo.pin !== F('pincode').value || noCod()) { ok.classList.remove('is-on'); return; }
    const a = area(), days = daysOf(a && a.days), n = maxDay(days);
    const cod = a && a.cod === false ? 'COD with a small advance' : 'COD available'; // COD allowed here only with an advance
    ok.textContent = `📍 ${pinInfo.city}, ${pinInfo.state} • ✅ ${cod} • by ${n ? `${etaText(n)} (${days} days)` : etaText()}`;
    ok.classList.add('is-on');
  }

  /* ---------- fields (in screen order) ---------- */
  const MOBILE = /^[6-9]\d{9}$/;
  const RULES = {
    name: (v) => (v.replace(/[^\p{L}]/gu, '').length >= 2 ? '' : 'Please enter your name'),
    phone: (v) => (MOBILE.test(v) ? '' : 'Enter a valid 10-digit mobile number'),
    alt_phone: (v) => (!FLD.altPhone.show ? '' : !v ? (FLD.altPhone.req ? 'Enter an alternate mobile number' : '') : MOBILE.test(v) ? '' : 'Enter a valid 10-digit mobile number'),
    email: (v) => { const x = v.trim(); return !FLD.email.show ? '' : !x ? (FLD.email.req ? 'Please enter your email' : '') : x.length <= 100 && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(x) ? '' : 'Enter a valid email address'; },
    address1: (v) => (v.trim().length >= 10 ? '' : 'Please enter your full address (house no., street, area)'),
    address2: (v) => (FLD.landmark.show && FLD.landmark.req && v.trim().length < 3 ? 'Please enter a landmark' : ''),
    pincode: (v) => (/^[1-9]\d{5}$/.test(v) ? '' : 'Enter a valid 6-digit pincode'),
    city: (v) => (v.trim().length >= 2 ? '' : 'Enter your city'),
    state: (v) => (v ? '' : 'Choose your state'),
  };
  const normNum = (n) => { const p = F(n); const d = p.value.replace(/\D/g, ''); p.value = d.length > 10 ? d.slice(-10) : d; };
  const normPhone = () => normNum('phone');
  function fieldErr(name, msg) {
    const f = $(`[data-f="${name}"]`); if (!f) return;
    f.classList.toggle('is-err', !!msg);
    const m = $('.bbcod-msg', f); if (m) m.textContent = msg || '';
    const input = F(name); if (input) input.setAttribute('aria-invalid', msg ? 'true' : 'false');
  }
  const clearFieldErr = (n) => fieldErr(n, '');
  function validate() {
    normPhone(); normNum('alt_phone');
    let first = null;
    Object.entries(RULES).forEach(([n, rule]) => { const msg = rule(F(n).value || ''); fieldErr(n, msg); if (msg && !first) first = F(n); });
    return first;
  }
  const allValid = () => Object.entries(RULES).every(([n, rule]) => !rule(F(n).value || ''));
  // the first empty field on screen (the steps template hides the other step's fields)
  const firstEmpty = () => ['name', 'phone', 'address1', 'pincode'].map((n) => F(n)).find((x) => !x.value && x.offsetParent !== null);
  const details = () => {
    const d = { name: F('name').value.trim(), phone: F('phone').value, address1: F('address1').value.trim(), address2: FLD.landmark.show ? F('address2').value.trim() : '', pincode: F('pincode').value, city: F('city').value.trim(), state: F('state').value };
    if (FLD.email.show && F('email').value.trim()) d.email = F('email').value.trim();
    if (FLD.altPhone.show && F('alt_phone').value) d.alt_phone = F('alt_phone').value;
    return d;
  };
  const SAVED = ['name', 'phone', 'alt_phone', 'email', 'address1', 'address2', 'pincode', 'city', 'state'];
  function prefill() {
    let d = null;
    try { d = JSON.parse(localStorage.getItem(STORE) || 'null'); } catch (e) { d = null; }
    if (!d) return;
    SAVED.forEach((n) => { if (d[n] && !F(n).value) F(n).value = d[n]; });
    if (F('pincode').value) onPin();
  }
  const remember = (d) => { try { localStorage.setItem(STORE, JSON.stringify(d)); } catch (e) { /* private mode */ } };

  /* ---------- half-filled forms (COD app: Half-filled forms; server POST /lead) ---------- */
  const leadIds = {}, leadSigs = {}; // per product (or cart) on this page: our lead id, the last saved details ('done' after an order)
  let idleT = 0;
  const leadKey = () => (mode === 'product' && P ? `p${P.id}` : `c${(lines[0] && lines[0].variant_id) || ''}`);
  const newLeadId = () => { try { return crypto.randomUUID().replace(/-/g, ''); } catch (e) { return `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`.slice(0, 32); } };
  const leadOpen = () => !order && (inlineForm() ? inl.seen : !root.hidden && curStep === 1);
  const idle = () => { clearTimeout(idleT); idleT = setTimeout(() => { if (leadOpen()) saveLead(); }, 120000); }; // 2 minutes without typing
  const STOP = [['name', 'Name'], ['phone', 'Mobile'], ['address1', 'Address'], ['pincode', 'Pincode'], ['city', 'City'], ['state', 'State']];
  function saveLead() {
    if (!LEADS.on || order || busy || !lines.length) return;
    const phone = F('phone').value.replace(/\D/g, '').slice(-10);
    if (!MOBILE.test(phone)) return;
    const k = leadKey();
    if (leadSigs[k] === 'done') return;
    const d = details(), l = lines[0];
    const product = mode === 'product' && P && variant
      ? { id: String(P.id), handle: P.handle || '', title: P.title, variant_id: String(variant.id), qty: pack, pack: packName(pack) }
      : { id: String(l.product_id || ''), handle: l.handle || '', title: lines.length > 1 ? `${l.title} + ${lines.length - 1} more` : l.title, variant_id: String(l.variant_id), qty: l.qty, pack: `Qty ${l.qty}` };
    const stop = STOP.find(([n]) => RULES[n](F(n).value || ''));
    const body = { id: leadIds[k] || (leadIds[k] = newLeadId()), phone, name: d.name, address1: d.address1, address2: d.address2, zip: d.pincode, city: d.city, state: d.state, email: d.email || '', alt_phone: d.alt_phone || '', product, value: (quote || estimate()).total, stopped: stop ? stop[1] : '' };
    const sig = JSON.stringify(body);
    if (sig === leadSigs[k]) return; // nothing changed since the last save
    leadSigs[k] = sig;
    post('/lead', { ...body, attr: attrNow(), consent: consentNow(), page_url: pageUrl(), form_version: formVersion, template: cur });
  }
  const leaving = () => { if (leadOpen()) saveLead(); };
  window.addEventListener('pagehide', leaving);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') leaving(); });
  function fillFrom(l) { // ?cod= resume: the half-filled details, never over what is typed already
    const map = { name: l.name, phone: l.phone, alt_phone: l.alt_phone, email: l.email, address1: l.address1, address2: l.address2, pincode: l.zip, city: l.city, state: l.state };
    Object.entries(map).forEach(([n, v]) => {
      const el = F(n);
      if (!el || v == null || v === '' || el.value) return;
      el.value = n === 'phone' || n === 'alt_phone' ? String(v).replace(/\D/g, '').slice(-10) : String(v);
    });
    if (F('pincode').value) onPin();
  }

  /* texts, optional fields and colours from the settings */
  function paintForm() {
    const tip = $('[data-cod-tip]');
    if (tip) { const t = [T.tip, T.tipHi].filter(Boolean).join(' • '); tip.textContent = t; tip.hidden = !t; }
    [['address2', FLD.landmark, 'Landmark'], ['email', FLD.email, 'Email'], ['alt_phone', FLD.altPhone, 'Alternate mobile']].forEach(([n, o, label]) => {
      const f = $(`[data-f="${n}"]`); if (!f) return;
      f.hidden = !o.show;
      F(n).disabled = !o.show;
      F(n).setAttribute('aria-required', o.req ? 'true' : 'false');
      $('label', f).innerHTML = `${esc(label)}${o.req ? '' : ' <i>(optional)</i>'}`;
      if (!o.show) clearFieldErr(n);
      const two = f.closest('.bbcod-two'); if (two) two.classList.toggle('is-one', !o.show); // Landmark hidden: Pincode full width (no :has() on older phones)
    });
    $('[data-cod-notice]').hidden = !LEADS.on;
    if (curStep === 1 && !(stepsOn() && sub === 2)) $('[data-cod-title]').textContent = T.title;
    const it = inl.host && inl.host.querySelector('#bbcod-inl-title'); if (it) it.textContent = inlTitle();
    if ((!root.hidden && curStep === 1) || inlineForm()) renderSummary();
  }
  function applySettings(s) {
    if (!s || typeof s !== 'object') return;
    const f = s.form || {};
    ['title', 'button'].forEach((k) => { if (typeof f[k] === 'string' && f[k].trim()) T[k] = f[k].trim(); });
    ['tip', 'tipHi'].forEach((k) => { if (typeof f[k] === 'string') T[k] = f[k].trim(); });
    const fl = f.fields || {};
    Object.keys(FLD).forEach((k) => { const x = fl[k]; if (x && typeof x === 'object') FLD[k] = { show: !!x.show, req: !!x.show && !!x.req }; });
    const c = f.colors || {};
    if (/^#[0-9a-fA-F]{6}$/.test(c.btn || '')) root.style.setProperty('--bbcod-btn', c.btn);
    if (/^#[0-9a-fA-F]{6}$/.test(c.btnText || '')) root.style.setProperty('--bbcod-btn-text', c.btnText);
    root.classList.toggle('bbcod--shake', f.shake === true);
    if (inl.host) { inl.host.style.cssText = root.style.cssText; inl.host.classList.toggle('bbcod--shake', f.shake === true); }
    if (typeof s.payOnline === 'boolean') payOn = s.payOnline;
    const d = s.delivery || {};
    if (Number(d.default) >= 0) DLV.def = Number(d.default);
    DLV.freeAbove = d.freeAbove != null && d.freeAbove !== '' && Number(d.freeAbove) >= 0 ? Number(d.freeAbove) : null;
    const eta = String(d.eta || '').match(/\d+/g);
    if (eta) etaDays = Math.min(30, Math.max(1, Number(eta[eta.length - 1])));
    if (typeof d.eta === 'string') DLV.eta = d.eta.trim();
    DLV.codFee = Math.min(500, Math.max(0, Math.round(Number(d.codFee) || 0)));
    DLV.rules = (Array.isArray(d.rules) ? d.rules : []).filter((r) => r && typeof r === 'object').slice(0, 50).map((r) => ({
      states: Array.isArray(r.states) ? r.states.map(String) : [],
      pins: Array.isArray(r.pins) ? r.pins.map(String).filter((p) => /^\d+x*$/i.test(p) && p.length === 6) : [],
      fee: r.fee == null || r.fee === '' || !(Number(r.fee) >= 0) ? null : Math.round(Number(r.fee)),
      days: typeof r.days === 'string' ? r.days.trim() : '',
      cod: r.cod !== false,
    })).filter((r) => r.states.length || r.pins.length);
    const o = s.offers || {}, op = o.prepaid || {}, ob = o.bump || {};
    const txt = (v) => (typeof v === 'string' ? v.trim() : '');
    OFF.pre = { on: op.on === true, type: op.type === 'pct' ? 'pct' : 'fixed', amount: Math.max(0, Number(op.amount) || 0), text: txt(op.text), code: txt(op.code) };
    OFF.bump = { on: ob.on === true, product: ob.product === 'same' ? 'same' : /^\d+$/.test(String(ob.product)) ? String(ob.product) : '', price: Math.round(Number(ob.price) || 0), text: txt(ob.text), showOn: ob.showOn === 'chosen' ? 'chosen' : 'all', products: Array.isArray(ob.products) ? ob.products.map(String) : [] };
    OFF.down = !!(o.downsell && o.downsell.on === true);
    OFF.coupon = !!(o.coupon && o.coupon.on === true);
    // Partial COD (the public part; the server keeps who is asked and decides every amount)
    const pa = s.partial && typeof s.partial === 'object' ? s.partial : {}, am = pa.amount && typeof pa.amount === 'object' ? pa.amount : {};
    const pos = (v, d) => (Number(v) > 0 ? Math.round(Number(v)) : d);
    Object.assign(PART, {
      on: pa.on === true, method: pa.method === 'razorpay' ? 'razorpay' : 'checkout', rzpKey: txt(pa.rzpKey),
      everyone: pa.everyone === true, everyoneOff: Math.min(500, Math.max(0, Math.round(Number(pa.everyoneOff) || 0))),
      amount: { mode: am.mode === 'pct' ? 'pct' : 'fixed', fixed: pos(am.fixed, 99), pct: Math.min(100, pos(am.pct, 20)), max: pos(am.max, 299), round: am.round === 'ten' ? 'ten' : 'nine' },
      codFee: pa.codFee === 'keep' ? 'keep' : 'waive', fullOnline: pa.fullOnline !== false, onRefusal: pa.onRefusal === 'keep' ? 'keep' : 'refund',
    });
    const u = s.upsell || {};
    if (Number(u.minutes) > 0) UPS.minutes = Math.min(30, Number(u.minutes));
    if (typeof u.heading === 'string' && u.heading.trim()) UPS.heading = u.heading.trim();
    if (P) {
      const pc = (s.products && s.products[String(P.id)]) || {};
      P.ownFee = typeof pc.fee === 'number' && pc.fee >= 0 ? pc.fee : P.feeMeta != null ? Number(P.feeMeta) || 0 : null; // the product's own charge
      P.fee = P.ownFee != null ? P.ownFee : DLV.def;
      P.codOnly = !!pc.codOnly || !!P.codOnlyMeta;
    }
    LEADS.on = !!(s.leads && s.leads.on === true);
    GEO.visits = !!(s.geo && s.geo.visits === true);
    consentOn = !!(s.consent && s.consent.on === true);
    chooseTemplate(s);
    paintForm();
  }
  /* public config from our server while the shop metafield is blank (shared with bb-pixels.js, 5-minute cache) */
  function remoteConfig() {
    if (window.bbCodConfigP) return window.bbCodConfigP;
    const KEY = 'bb_cod_cfg';
    window.bbCodConfigP = (async () => {
      try { const c = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (c && c.v && Date.now() - c.at < 300000) return c.v; } catch (e) { /* no cache */ }
      try {
        const r = await fetch(`${API}/config`, { headers: { Accept: 'application/json' } });
        if (!r.ok) return null;
        const d = await r.json();
        const v = d && typeof d === 'object' ? (d.config && typeof d.config === 'object' ? d.config : d.settings && typeof d.settings === 'object' ? d.settings : d) : null;
        if (!v || !(v.form || v.pixels || v.mode)) return null;
        try { sessionStorage.setItem(KEY, JSON.stringify({ at: Date.now(), v })); } catch (e) { /* private mode */ }
        return v;
      } catch (e) { return null; }
    })();
    return window.bbCodConfigP;
  }

  /* ---------- errors + the one live region (in the form, so it moves with the inline template) ---------- */
  let sayT = 0;
  function say(msg) {
    const el = form.querySelector('[data-cod-live]');
    if (!el || !msg) return;
    el.textContent = '';
    clearTimeout(sayT);
    sayT = setTimeout(() => { el.textContent = msg; }, 80); // emptied first, so the same text is read again
  }
  function showErr(msg, where) { const e = $(where || '[data-cod-err]'); e.textContent = msg; e.hidden = false; say(msg); }
  function hideErr() { [...root.querySelectorAll('.bbcod-err'), ...(root.contains(form) ? [] : form.querySelectorAll('.bbcod-err'))].forEach((e) => { e.hidden = true; }); }

  /* ---------- Turnstile (optional bot check) ---------- */
  function loadTurnstile() {
    if (!cfg.turnstile || tsWidget !== null) return;
    tsWidget = false;
    const render = () => {
      try {
        tsWidget = window.turnstile.render($('[data-cod-ts]'), { sitekey: cfg.turnstile, appearance: 'interaction-only', action: 'cod_order', callback: (t) => { tsToken = t; }, 'expired-callback': () => { tsToken = ''; }, 'error-callback': () => { tsToken = ''; } });
      } catch (e) { tsWidget = null; }
    };
    if (window.turnstile) { render(); return; }
    window.bbcodTsReady = render;
    const s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=bbcodTsReady';
    s.async = true; s.defer = true;
    document.head.appendChild(s);
  }
  async function tsTokenNow() {
    if (!cfg.turnstile) return '';
    for (let i = 0; i < 30 && !tsToken; i++) await new Promise((r) => setTimeout(r, 200));
    return tsToken;
  }
  const tsReset = () => { tsToken = ''; try { if (window.turnstile && tsWidget) window.turnstile.reset(tsWidget); } catch (e) { /* ignore */ } };

  /* ---------- place order ---------- */
  async function place(e) {
    e.preventDefault();
    if (busy || held()) return;
    hideErr();
    if (stepsOn() && sub === 1) { next(); return; } // steps template: NEXT: ADDRESS
    if (!quote && quoteState === 'error') { requestQuote(0); return; }
    // a no-COD area (the rules on the page) while Partial COD is on and the quote isn't here yet: /order says whether an
    // advance is taken there (409 ADVANCE), else Pay online. Once the quote is here its cod_allowed says it (no probe)
    const probe = payNowOn && PART.on && !quote && noCod() && !adv && !forcePay && allValid();
    if (payNowOn && !probe) { goOnline(); return; } // Pay online picked, a no-COD area or high risk
    const bad = validate();
    if (bad) { if (stepsOn() && G1.includes(bad.name)) setSub(1); bad.focus(); bad.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
    busy = true;
    const btn = $('[data-cod-place]');
    btn.disabled = true; btn.innerHTML = advOn ? 'Opening payment…' : probe ? 'Please wait…' : 'Placing your order…';
    if (!quote) {
      const shown = estimate().total;
      await waitQuote(12000); // also through a retry of the quote
      if (!quote) { busy = false; btn.disabled = false; renderSummary(); showErr('Couldn\'t load the price. Please check your internet and try again.'); return; }
      // Pay online was tapped: go on to /order only where the quote says COD is taken with an advance, else Pay online
      if (probe && !advArea()) { busy = false; btn.disabled = false; renderSummary(); goOnline(); return; }
      if (Math.abs(quote.total - shown) > 0.5) { busy = false; btn.disabled = false; renderSummary(); showErr(`The price is ${inr(quote.total)} (not ${inr(shown)}). Please check and tap ${T.button} again.`); return; }
    }
    const d0 = details(), fee0 = Number(quote.cod_fee) || 0; // fee0: the COD fee of the quote the order is placed with
    const k = leadKey();
    const body = { lines: payloadLines(), customer: d0, source: mode, discount_codes: codesNow(), upsell_candidates: hints, delivery_hint: quote.delivery, key: subKey, expected_total: quote.total, ts: await tsTokenNow(),
      lead_id: leadIds[k] || '', attr: attrNow(), consent: consentNow(), page_url: pageUrl(), form_version: formVersion, ab_id: abId, template: cur };
    if (bumpSent()) body.bump = true;
    if (advOn) { payAdvance(body, d0, fee0, k); return; } // the advance card: no order until the advance is paid
    let res = await api('/order', body, 30000);
    // outcome unknown (connection dropped / Shopify slow): ask again with the same id – never a second order
    for (let i = 0; i < 8 && !res.ok && (res.status === 0 || res.unknown || res.pending); i++) {
      btn.innerHTML = 'Confirming your order…';
      await new Promise((r) => setTimeout(r, 5000));
      res = await api('/order', body, 30000);
    }
    busy = false; btn.disabled = false;
    tsReset();
    if (!res.ok && res.code === 'ADVANCE' && res.advance) { askAdvance(res, body.expected_total); return; }
    if (probe && !res.ok && !res.fields && !res.quote) { goOnline(); return; } // no advance in this area: Pay online, as before
    if (failed(res)) return;
    placed(res, d0, fee0, k);
  }
  // a failed /order or /advance: Pay online instead (high risk / no COD), a new price, field errors or a message
  function failed(res) {
    if (res.ok) return false;
    const btn = $('[data-cod-place]');
    if (res.payOnline) { // high risk (409) or a no-COD area (403): no order, Pay online instead
      forcePay = true; adv = null;
      syncBump(); btn.focus(); // the bump (Cash on Delivery only) goes: priced again without it
      showErr(res.error || 'Please pay online for this order.');
      return true;
    }
    if (res.quote) { quote = res.quote; quoteState = 'ok'; } // the price changed: show the new one, the customer confirms again
    renderSummary();
    if (res.fields) {
      const OPT = { address2: 'landmark', email: 'email', alt_phone: 'altPhone' };
      let opened = false;
      Object.keys(res.fields).forEach((n) => { const k2 = OPT[n]; if (k2 && !FLD[k2].show) { FLD[k2] = { show: true, req: true }; opened = true; } });
      if (opened) { paintForm(); try { sessionStorage.removeItem('bb_cod_cfg'); } catch (er) { /* private mode */ } } // settings changed: next page loads them fresh
      Object.entries(res.fields).forEach(([n, m]) => fieldErr(n, m));
      const f = Object.keys(res.fields)[0];
      if (F(f)) { if (stepsOn() && G1.includes(f)) setSub(1); F(f).focus(); }
    }
    else btn.focus();
    showErr(res.pending || res.unknown ? 'We could not confirm your order yet. Please don\'t order again – check your messages, or contact us if nothing arrives in 10 minutes.' : (res.error || 'Something went wrong. Please try again.'));
    return true;
  }
  // the order is placed (/order, or /advance/verify after a Razorpay advance): upsell, then the thank-you screen
  function placed(res, d0, fee0, k) {
    order = res.order;
    if (order.cod_fee == null) order.cod_fee = fee0; // the thank-you screen's COD fee line (/order doesn't send it)
    leadSigs[k] = 'done'; clearTimeout(idleT); // ordered: no half-filled form for this product any more
    remember(d0);
    if (mode === 'cart') fetch(`${shopRoot}cart/clear.js`, { method: 'POST', headers: { Accept: 'application/json' } }).catch(() => {});
    if (!res.duplicate) track(order, d0); // a repeat of an earlier order was counted when it was placed
    upsell = res.upsell;
    if (!root.contains(form)) { renderSummary(); overlay(); } // inline template: upsell + thank you as the full-screen sheet
    if (upsell) showUpsell(); else thanks();
  }

  /* ---------- Phase 4: paying the advance ---------- */
  // 409 ADVANCE from /order: the advance card (picked) and "Pay in full online" replace Cash on Delivery (base: the total asked for)
  function askAdvance(res, base) {
    const x = res.advance, n = (v) => Math.max(0, Number(v) || 0);
    if (!(n(x.amount) > 0)) { showErr(res.error || 'Something went wrong. Please try again.'); return; }
    adv = { amount: n(x.amount), balance: n(x.balance), off: n(x.off), codFee: n(x.codFee), waived: x.waived === true, method: x.method === 'razorpay' ? 'razorpay' : 'checkout',
      onRefusal: x.onRefusal === 'keep' ? 'keep' : 'refund', fullOnline: x.fullOnline !== false, reason: x.reason === 'area' || x.reason === 'pin' ? x.reason : 'risk', base: Number(base) || 0, phone: F('phone').value };
    forcePay = false; payPick = 'adv';
    renderSummary();
    say(res.error || advNote(adv.amount));
    if (adv.method === 'razorpay') loadRzp().catch(() => {}); // ready when they tap
    const pc = $('[data-cod-pay]');
    if (pc && !pc.hidden) { try { pc.scrollIntoView({ block: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); } catch (er) { /* old browsers */ } }
    $('[data-cod-place]').focus({ preventScroll: true });
  }
  // POST /advance (choice 'forced' after a 409 ADVANCE, 'optional' for the everyone-mode card); the server prices it again
  async function payAdvance(body, d0, fee0, k) {
    const btn = $('[data-cod-place]');
    const x = advNums(quote) || {};
    const choice = adv ? 'forced' : 'optional';
    const res = await api('/advance', { ...body, choice }, 30000);
    tsReset();
    // the same order was placed already (a repeat of this submission): its answer, like /order's
    if (res.ok && res.duplicate && res.order) { busy = false; btn.disabled = false; placed(res, d0, fee0, k); return; }
    if (!res.ok) {
      busy = false; btn.disabled = false;
      if (res.code === 'ADVANCE' && res.advance) { askAdvance(res, body.expected_total); return; } // now required (e.g. risk): the server's numbers
      if (res.code === 'NO_ADVANCE') { // not needed any more (e.g. another mobile number, or the offer to everyone is off): COD again
        if (choice === 'optional') { PART.everyone = false; try { sessionStorage.removeItem('bb_cod_cfg'); } catch (er) { /* private mode */ } }
        adv = null; payPick = 'cod';
        renderSummary(); showErr(res.error || 'The advance is not needed any more. Please place the order again.'); btn.focus();
        return;
      }
      failed(res);
      return;
    }
    // the server's numbers; the ₹ off: the server's, else the card's while the server's advance + balance are the card's
    // (none when it made the advance a required one)
    const amount = nv(res.advance, x.amount || 0), balance = nv(res.balance, x.balance || 0);
    const off = nv(res.off, amount === (x.amount || 0) && Math.abs(balance - (x.balance || 0)) < 0.01 ? x.off || 0 : 0);
    const info = { id: String(res.id || ''), amount, balance, off, waived: !!x.waived };
    if (res.method === 'razorpay' && res.razorpay && res.razorpay.order_id) { rzpPay(res.razorpay, info, d0, fee0, k); return; }
    // checkout: the Shopify checkout of the advance; the server makes the COD order once it is paid (webhook)
    const raw = typeof res.url === 'string' ? res.url.trim() : ''; // never '' (that is this page)
    let url = null;
    try { url = raw ? new URL(raw, location.href) : null; } catch (er) { url = null; }
    if (!url || !(/^https?:$/.test(url.protocol) || raw.startsWith('#'))) { busy = false; btn.disabled = false; renderSummary(); showErr('Payment could not be opened. Please try again.'); return; }
    bbTrack('AddPaymentInfo', { value: info.amount, currency: 'INR', contents: contents(lines), form_version: formVersion, template: cur });
    try { sessionStorage.setItem('bbcod_adv', info.id); } catch (er) { /* private mode */ }
    busy = false;
    saveLead(); // until the advance is paid the details stay a half-filled form
    redirecting = true;
    btn.disabled = true; btn.innerHTML = 'Opening secure checkout…';
    location.href = url.href;
  }
  // Razorpay in the form: checkout.js with the server's order; paid → POST /advance/verify (answers like /order)
  async function rzpPay(r, info, d0, fee0, k) {
    const btn = $('[data-cod-place]');
    const stop = () => { busy = false; btn.disabled = false; if (!root.hidden) pageInert(true); renderSummary(); showErr('Payment not completed. Please try again.'); btn.focus(); };
    try { await loadRzp(); } catch (er) { stop(); return; }
    let paid = false;
    try {
      const rz = new window.Razorpay({
        key: r.key, order_id: r.order_id, amount: r.amount, currency: 'INR', name: r.name || 'Bazaar Bee',
        description: 'Advance for your Cash on Delivery order',
        prefill: r.prefill && typeof r.prefill === 'object' ? r.prefill : {},
        notes: r.notes && typeof r.notes === 'object' ? r.notes : {}, // on the payment: the webhook finds the advance
        theme: { color: '#FFB000' },
        handler: (p) => { paid = true; if (!root.hidden) pageInert(true); verifyAdvance(info, p || {}, d0, fee0, k); },
        modal: { ondismiss: () => { if (!paid) stop(); } },
      });
      pageInert(false); // checkout.js puts its window at the end of the page: it must stay reachable
      rz.open();
    } catch (er) { stop(); }
  }
  async function verifyAdvance(info, p, d0, fee0, k) {
    const btn = $('[data-cod-place]');
    btn.disabled = true; btn.innerHTML = 'Confirming your order…';
    const body = { id: info.id, razorpay_payment_id: p.razorpay_payment_id, razorpay_order_id: p.razorpay_order_id, razorpay_signature: p.razorpay_signature };
    let res = await api('/advance/verify', body, 30000);
    // the advance is paid: ask again until the order is confirmed (the server makes it only once)
    for (let i = 0; i < 8 && !res.ok && (res.status === 0 || res.status === 409 || res.status >= 500 || res.unknown || res.pending); i++) {
      await new Promise((r) => setTimeout(r, 5000));
      res = await api('/advance/verify', body, 30000);
    }
    busy = false;
    if (!res.ok || !res.order) {
      paidHold = subKey; // no second payment for this submission; the server's backstops finish the order
      btn.disabled = true; btn.innerHTML = 'Advance paid · confirming your order';
      showErr('Your advance is paid. We could not confirm the order yet – please don\'t pay again. Contact us if you hear nothing in 10 minutes.');
      return;
    }
    btn.disabled = false;
    // the thank-you lines, with the server's advance, balance and ₹ off when it sends them; base: the total before an upsell
    const sa = res.order.advance && typeof res.order.advance === 'object' ? res.order.advance : {};
    res.order.adv = { ...info, amount: nv(sa.amount, info.amount), balance: nv(sa.balance, info.balance), off: nv(sa.off, info.off), base: Number(res.order.total) || 0 };
    placed(res, d0, fee0, k);
  }
  function buyer(d) { // Google Ads enhanced conversions (bb-pixels.js hands it to gtag, which hashes it)
    const n = String(d.name || '').trim(), i = n.indexOf(' ');
    const st = [...F('state').options].find((o) => o.value === d.state);
    return { phone: `+91${d.phone}`, first_name: i > 0 ? n.slice(0, i) : n, last_name: i > 0 ? n.slice(i + 1).trim() : '', city: d.city, region: st ? st.text : '', postal_code: d.pincode };
  }
  function track(o, d) {
    if (window.bbTrack) {
      bbTrack('Purchase', { value: o.total, currency: 'INR', order_id: o.name, event_id: `cod-${o.id || o.name}`, contents: (o.items || []).map((l) => ({ id: l.variant_id, pid: l.product_id, quantity: l.qty, item_price: l.unit })), form_version: formVersion, template: cur, user: buyer(d) });
      return;
    }
    // no pixel loader on this page: pixels added some other way
    try { if (window.fbq) window.fbq('track', 'Purchase', { value: o.total, currency: 'INR' }); } catch (e) { /* ignore */ }
    try { if (window.gtag) window.gtag('event', 'purchase', { transaction_id: o.name, value: o.total, currency: 'INR' }); } catch (e) { /* ignore */ }
  }

  /* ---------- upsell ---------- */
  function showUpsell() { // the one-time offer, or the downsell (kind 'dn': red card, its own heading and timer)
    const u = upsell, dn = u.kind === 'dn';
    $('[data-cod-oid]').textContent = `${order.name} • ${inr(order.adv ? order.adv.balance : order.total)} on delivery`;
    $('[data-cod-ups]').classList.toggle('is-dn', dn);
    $('[data-cod-ups-head]').textContent = dn ? u.heading || 'WAIT! ONE LAST OFFER' : `${UPS.heading} • picked for you`;
    $('[data-cod-upsell]').innerHTML = `${img(u.image, 160, 70)}<div><b>${esc(u.title)}${u.variant_title ? ` – ${esc(u.variant_title)}` : ''}</b><div class="bbcod-ups-pr">${inr(u.price)}${u.compare > u.price ? `<s>${inr(u.compare)}</s>` : ''}${u.pct ? `<em>${esc(u.pct)}% OFF</em>` : ''}</div></div>`;
    $('[data-cod-yes]').innerHTML = `YES, ADD · ${inr(u.price)}`;
    step(2);
    if (!dn) beacon('upsell_view');
    $('[data-cod-yes]').focus({ preventScroll: true });
    const mins = Number(u.minutes) > 0 ? Number(u.minutes) : dn ? 3 : UPS.minutes;
    let s = Math.max(60, Math.round(mins * 60)) - 1;
    const tick = () => { $('[data-cod-timer]').textContent = `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`; };
    tick();
    clearInterval(timer);
    timer = setInterval(() => {
      s--; tick();
      if (s <= 0) { clearInterval(timer); thanks(); }
    }, 1000);
  }
  let upsellState = ''; // '' | 'adding' | 'added' | 'failed' | 'unsure'
  async function acceptUpsell() {
    if (upsellState || !upsell) return;
    const o = order, u = upsell; // the inline form may start a new order before this finishes
    upsellState = 'adding'; upsellAdded = true;
    const base = o.total;
    o.total = base + u.price;
    thanks(); // straight to the thank-you screen; the extra item is added to the order meanwhile
    let r = await api('/upsell', { token: u.token }, 30000);
    for (let i = 0; i < 2 && !r.ok && (r.status === 0 || r.status === 429 || r.status >= 500); i++) {
      await new Promise((res) => setTimeout(res, 3000));
      r = await api('/upsell', { token: u.token }, 30000); // safe: the server adds it only once per order
    }
    const mine = order === o;
    if (r.ok) {
      if (mine) upsellState = 'added';
      if (r.total) o.total = r.total;
      bbTrack('UpsellAccepted', { value: u.price, currency: 'INR', order_id: o.name, event_id: `${u.kind === 'dn' ? 'dn' : 'up'}-${o.id || o.name}`, contents: [{ id: u.variant_id, pid: u.product_id, quantity: 1, item_price: u.price }] });
    } else if (r.status === 0 || r.status >= 500) { if (mine) upsellState = 'unsure'; o.totalNote = 'We\'ll confirm the final amount.'; }
    else { if (mine) { upsellState = 'failed'; upsellAdded = false; } o.total = base; }
    if (mine && !root.hidden) thanks();
  }
  // "No thanks": after the one-time offer the server may have one smaller offer (once per order), else the thank-you screen
  async function declineOffer() {
    if (!upsell || upsell.kind === 'dn' || !OFF.down || dnTried || !upsell.token) { thanks(); return; }
    dnTried = true;
    clearInterval(timer);
    const o = order, yes = $('[data-cod-yes]'), no = $('[data-cod-no]');
    yes.disabled = true; no.disabled = true;
    const d = await api('/downsell', { token: upsell.token }, 6000);
    yes.disabled = false; no.disabled = false;
    if (order !== o || root.hidden || curStep !== 2) return; // closed meanwhile
    const f = d && d.ok !== false && d.offer && typeof d.offer === 'object' ? d.offer : null;
    if (!f || !d.token || !(Number(f.price) > 0)) { thanks(); return; }
    upsell = { kind: 'dn', token: d.token, title: String(f.title || ''), variant_title: '', image: f.image || '', price: Number(f.price), compare: Number(f.compare_at) || 0, pct: Number(f.pct) || 0, variant_id: f.variant_id, minutes: f.minutes, heading: String(f.heading || '').trim() };
    showUpsell();
  }

  /* ---------- thank you ---------- */
  function thanks() {
    clearInterval(timer);
    $('[data-cod-thanks]').textContent = `Thank you, ${order.first_name || 'friend'}! 🎉`;
    $('[data-cod-oid2]').textContent = `Order ${order.name}`;
    let rows = (order.items || []).map((l) => `<div class="bbcod-line"><span>${esc(l.title)}${l.variant_title ? ` – ${esc(l.variant_title)}` : ''} × ${esc(l.qty)}</span><b>${inr(l.total)}</b></div>`).join('');
    const upNote = { adding: '⏳ adding…', added: '✓', unsure: '<small>we\'ll confirm it soon</small>' }[upsellState] || '';
    if (upsellAdded) rows += `<div class="bbcod-line"><span>${esc(upsell.title)} (offer) ${upNote}</span><b>${inr(upsell.price)}</b></div>`;
    else if (upsellState === 'failed') rows += `<div class="bbcod-line"><span>${esc(upsell.title)} <small>– sorry, it could not be added; your order is placed without it</small></span><b></b></div>`;
    if (order.delivery > 0) rows += `<div class="bbcod-line"><span>🚚 Delivery</span><b>${inr(order.delivery)}</b></div>`;
    const av = order.adv || null; // Partial COD: the advance paid (Razorpay) and the balance to pay on delivery
    if (order.cod_fee > 0 && !(av && av.waived)) rows += `<div class="bbcod-line"><span>COD fee</span><b>${inr(order.cod_fee)}</b></div>`;
    if (av) {
      if (av.off > 0) rows += `<div class="bbcod-line is-g"><span>Advance discount</span><b>−${inr(av.off)}</b></div>`;
      rows += `<div class="bbcod-line is-g"><span>${inr(av.amount)} advance received</span><b>−${inr(av.amount)}</b></div>`;
    }
    $('[data-cod-lines]').innerHTML = rows;
    $('[data-cod-to]').textContent = order.address || '';
    $('[data-cod-to-row]').hidden = !order.address;
    const a = localArea(); // the delivery days of the area (the form still holds the pincode + state)
    $('[data-cod-eta]').textContent = etaText(maxDay(daysOf(a && a.days)));
    // with an advance: "Pay on delivery ₹<balance>" (+ an upsell added meanwhile)
    const due = av ? av.balance + Math.max(0, (Number(order.total) || 0) - av.base) : order.total;
    $('[data-cod-total-l]').textContent = 'Pay on delivery';
    $('[data-cod-total]').textContent = `${inr(due)}${order.totalNote ? ' (+ extra item if added)' : ''}`;
    step(3);
    $('[data-cod-done]').focus({ preventScroll: true });
  }

  /* ---------- pay online (normal Shopify checkout) ---------- */
  async function payOnline() {
    const b = $('[data-cod-payonline]');
    if (mode === 'product') {
      b.disabled = true;
      try {
        const r = await fetch(`${shopRoot}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: pack }] }) });
        if (!r.ok) throw new Error(String(r.status));
      } catch (e) { b.disabled = false; showErr('Sorry, please try again.'); return; }
    }
    location.href = `${shopRoot}checkout`;
  }
  /* the green PAY ONLINE button (prepaid picked, no-COD area, high risk): a Shopify cart permalink with every line, the
     one discount code of online() and the address filled in; the lead is saved first. No bump: it is Cash on Delivery
     only (a link can't carry its price), so it is hidden while paying online */
  function goOnline() {
    if (redirecting) return;
    saveLead(); // closed without a COD order (Phase 2 rules)
    const q = quote || estimate();
    const qty = new Map();
    const add = (v, n) => { const k = String(v || ''); if (/^\d+$/.test(k) && n > 0) qty.set(k, (qty.get(k) || 0) + n); };
    lines.forEach((l) => add(l.variant_id, l.qty));
    if (!qty.size) return;
    const p = new URLSearchParams();
    const code = online(q).code;
    if (code) p.set('discount', code);
    const d = details(), i = d.name.indexOf(' '), A = 'checkout[shipping_address]';
    const put = (k, v) => { if (v) p.set(`${A}[${k}]`, v); };
    put('first_name', i > 0 ? d.name.slice(0, i) : d.name);
    put('last_name', i > 0 ? d.name.slice(i + 1).trim() : '');
    put('address1', d.address1); put('address2', d.address2); put('city', d.city); put('province', stateName(d.state));
    put('zip', okPin(d.pincode) ? d.pincode : ''); put('country', 'India'); put('phone', MOBILE.test(d.phone) ? `+91${d.phone}` : '');
    redirecting = true;
    const b = $('[data-cod-place]');
    b.disabled = true; b.innerHTML = 'Opening secure checkout…';
    location.href = `${shopRoot}cart/${[...qty].map(([v, n]) => `${v}:${n}`).join(',')}?${p}`;
  }
  // back from checkout (page restored from the browser cache): fresh state
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    busy = false; redirecting = false; $('[data-cod-payonline]').disabled = false;
    if (inlineForm()) renderSummary();
    close();
  });

  /* ---------- events ---------- */
  form.addEventListener('submit', place);
  form.addEventListener('input', (e) => {
    const n = e.target.name;
    if (!typed && e.target.type !== 'radio' && e.target.type !== 'checkbox') { typed = true; beacon('typed'); } // a pick is not typing
    if (n === 'phone' || n === 'alt_phone') normNum(n);
    // an advance asked for this mobile number's risk: another number, /order decides again (as a new pincode does for 'area')
    if (n === 'phone' && adv && adv.reason === 'risk' && !busy && F('phone').value !== adv.phone) { adv = null; payPick = 'cod'; renderSummary(); }
    if (n === 'pincode') onPin();
    else {
      if (n === 'city' || n === 'state') delete e.target.dataset.auto;
      if (n && $(`[data-f="${n}"]`) && $(`[data-f="${n}"]`).classList.contains('is-err')) fieldErr(n, RULES[n] ? RULES[n](e.target.value || '') : '');
    }
    if (!filled && allValid()) { filled = true; beacon('filled'); }
    idle();
  });
  form.addEventListener('change', (e) => {
    const n = e.target.name;
    if (n === 'state') { delete e.target.dataset.auto; clearFieldErr('state'); areaChanged(150); }
    if (n === 'bbcod_pay') {
      const v = e.target.value;
      payPick = v === 'online' || v === 'adv' ? v : 'cod';
      hideErr(); syncBump();
      if (payPick === 'adv' && advMethod() === 'razorpay') loadRzp().catch(() => {}); // ready when they tap
    }
  });
  form.addEventListener('keydown', (e) => { if (e.key === 'Enter' && e.target.name === 'coupon') { e.preventDefault(); applyCoupon(); } }); // Enter applies the code, never places the order
  function applyCoupon() {
    const el = F('coupon');
    const c = el.value.trim().toUpperCase().slice(0, 60); // Shopify codes ignore case
    el.value = c;
    if (!c) { el.focus(); return; }
    if (sameCode(c, coupon.code) && coupon.st && coupon.st !== 'wait') return; // already checked
    coupon = { code: c, st: 'wait' }; couponOff = null;
    requestQuote(0);
  }
  function removeCoupon() {
    coupon = { code: '', st: '' }; couponOff = null;
    F('coupon').value = '';
    requestQuote(0);
    F('coupon').focus();
  }
  // clicks in the sheet, and in the product page card while the form sits there (inline template)
  function onClick(e) {
    const t = e.target;
    if (t.closest('[data-cod-close]')) return close();
    if (t.closest('[data-cod-back], [data-cod-edit]')) return back();
    const pk = t.closest('[data-cod-pack]');
    if (pk) { pack = +pk.dataset.codPack; setProductLines(); renderItems(); requestQuote(); if (inlineForm()) inlinePack(); return; }
    if (t.closest('[data-cod-payonline]')) return payOnline();
    if (t.closest('[data-cod-bump]')) { if (!busy) { bump = !bump; requestQuote(0); } return; }
    if (t.closest('[data-cod-cpl]')) { cpOpen = true; renderSummary(); F('coupon').focus(); return; }
    if (t.closest('[data-cod-cpapply]')) return applyCoupon();
    if (t.closest('[data-cod-cprm]')) return removeCoupon();
    if (t.closest('[data-cod-yes]')) return acceptUpsell();
    if (t.closest('[data-cod-no]')) return declineOffer();
    if (t.closest('[data-cod-done]')) return close();
  }
  root.addEventListener('click', onClick);
  document.addEventListener('keydown', (e) => {
    if (root.hidden) return;
    if (e.key === 'Escape') { if (!busy) close(); return; }
    if (e.key === 'Tab') { // keep focus inside the form
      const f = [...root.querySelectorAll('.bbcod-back, .bbcod-x, .bbcod-step.is-on button:not([disabled]):not([hidden]), .bbcod-step.is-on input:not([disabled]), .bbcod-step.is-on select, .bbcod-step.is-on textarea')].filter((x) => x.offsetParent !== null);
      if (!f.length) return;
      const i = f.indexOf(document.activeElement);
      if (i === -1) { e.preventDefault(); (e.shiftKey ? f[f.length - 1] : f[0]).focus(); }
      else if (e.shiftKey && i === 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* take over the store's checkout buttons (capture: runs before their own handlers) */
  document.addEventListener('click', (e) => {
    if (off || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    const t = e.target;
    const ob = t.closest && t.closest('bb-buy-box [data-order]');
    if (ob) {
      const bx = ob.closest('bb-buy-box');
      if (ob.disabled) return;
      if (openProduct(bx, ob)) { e.preventDefault(); e.stopImmediatePropagation(); }
      return;
    }
    const a = t.closest && t.closest('a[href]');
    if (a && !a.closest('#bb-cod')) {
      let u; try { u = new URL(a.href, location.href); } catch (er) { return; }
      if (u.origin === location.origin && /\/checkout\/?$/.test(u.pathname)) { e.preventDefault(); e.stopImmediatePropagation(); openCart(); }
    }
  }, true);

  if (P) {
    const warm = () => {
      if (off) return;
      const bx = document.querySelector('bb-buy-box');
      const vid = Number((bx && bx.variantId && bx.variantId()) || (P.variants[0] && P.variants[0].id));
      const v = P.variants.find((x) => x.id === vid);
      if (!v || !v.available) return;
      const n = Math.max(1, Number((bx && bx.qty && bx.qty()) || 1));
      let sv = null; // the saved details fill the form: the same pincode + state make the same quote
      try { sv = JSON.parse(localStorage.getItem(STORE) || 'null'); } catch (e) { sv = null; }
      const ar = areaParams(F('pincode').value || String((sv && sv.pincode) || ''), F('state').value || String((sv && sv.state) || ''));
      fetchQuote([{ variant_id: v.id, qty: n }], [], hintFor(v, n), ar);
    };
    const idleCb = window.requestIdleCallback || ((f) => setTimeout(f, 1200));
    // not on every page view: on the first touch of the buy box (finger, keyboard, pack picked), or once the shopper has
    // stayed 3 s on the product page (the quote is cached for 2 minutes, so a second warm costs nothing)
    window.addEventListener('load', () => setTimeout(() => idleCb(warm, { timeout: 4000 }), 3000), { once: true });
    const inBox = (e) => !!(e.target.closest && e.target.closest('bb-buy-box'));
    document.addEventListener('pointerdown', (e) => { if (inBox(e)) warm(); }, { capture: true, passive: true });
    document.addEventListener('focusin', (e) => { if (inBox(e) && !(inl.host && inl.host.contains(e.target))) warm(); }, true);
    document.addEventListener('change', (e) => { if (inBox(e)) setTimeout(warm, 50); }, true);
  }

  /* ?cod=<token> (WhatsApp link to a half-filled form) and ?codopen=1 (template preview), product pages only */
  let openNow = false, resumeP = null;
  if (P) {
    try {
      const u = new URL(location.href);
      const t = u.searchParams.get('cod') || '';
      openNow = u.searchParams.get('codopen') === '1';
      if (/^[A-Za-z0-9_-]{8,64}$/.test(t)) resumeP = api(`/lead/resume?t=${encodeURIComponent(t)}`, null, 8000); // errors stay silent
      if (u.searchParams.has('cod') || u.searchParams.has('codopen')) {
        u.searchParams.delete('cod'); u.searchParams.delete('codopen');
        history.replaceState(history.state, '', `${u.pathname}${u.search}${u.hash}`);
      }
    } catch (e) { resumeP = null; }
  }
  async function arrive() {
    if (!P || off || (!resumeP && !openNow)) return;
    const bx = document.querySelector('bb-buy-box');
    if (!bx) return;
    let want = null;
    if (resumeP) {
      const d = await resumeP;
      const l = d && d.ok && d.lead && typeof d.lead === 'object' ? d.lead : null;
      if (l) { fillFrom(l); want = { variant: Number(l.variant_id) || 0, qty: Number(l.qty) || 0 }; }
      else if (!openNow) return;
    }
    if (busy || !root.hidden) return;
    if (inlineForm()) {
      if (want) {
        const v = want.variant && P.variants.find((x) => x.id === want.variant && x.available);
        if (v) inl.variant = variant = v;
        if (want.qty > 0) pack = Math.min(20, Math.floor(want.qty));
        setProductLines(); renderItems(); requestQuote(); inlinePack();
      }
      toInline();
    } else openProduct(bx, null, want);
  }

  /* settings: from the page (shop metafield), else from our server once it answers */
  const ready = (cfg.settings && typeof cfg.settings === 'object')
    ? Promise.resolve(applySettings(cfg.settings))
    : remoteConfig().then((s) => { if (!s) return; if (s.mode && !modeOk(s.mode)) off = true; applySettings(s); }).catch(() => {});
  ready.then(() => {
    mountInline();
    if (document.readyState === 'complete') arrive().catch(() => {});
    else window.addEventListener('load', () => { arrive().catch(() => {}); }, { once: true });
  });
  /* Location insights: one 'visit' per browser session, once the page is idle (the server keeps the area, never the IP) */
  ready.then(() => {
    if (!GEO.visits) return;
    const visit = () => {
      try { if (sessionStorage.getItem('bb_cod_visit')) return; sessionStorage.setItem('bb_cod_visit', '1'); } catch (e) { return; } // no session storage: not counted (it would count every page)
      beacon('visit');
    };
    const idleCb = window.requestIdleCallback || ((f) => setTimeout(f, 1200));
    const later = () => idleCb(visit, { timeout: 5000 });
    if (document.readyState === 'complete') later();
    else window.addEventListener('load', later, { once: true });
  });

  window.bbCheckout = () => { openCart(); };
  window.BBCOD = { openCart, openProduct, close };
})();
